// // import AdminSidebar from "admin/sidebar/AdminSidebar";
// // import { useEffect, useMemo, useState } from "react";
// // import axios from "axios";
// // import * as XLSX from "xlsx";
// // import { getReadableOrderId } from "pages/utils/HelperFun";
// // import moment from "moment";
// // import { formatDate, formatTimeInTimezone } from "pages/utils/formdatedynamics";

// // const API_BASE = process.env.REACT_APP_API_URL || 'https://backend.washta.com';
// // const ADMIN_BASE = `${API_BASE}/api/admin`;

// // const safeNumber = (value) => {
// //   const parsed = Number(value ?? 0);
// //   return Number.isFinite(parsed) ? parsed : 0;
// // };

// // const getOrderNumber = (data, prefix = 'WS') => {
// //   console.log('data',data)
// //   const id = typeof data === 'string'
// //     ? data
// //     : data?._id || data?.id;

// //   if (!id) return `${prefix}-—`;

// //   return getReadableOrderId(String(id), prefix);
// // };
// // const formatLocation = (order) => order.serviceLocation?.text || order.shopLocationText || order.shopId?.location?.text || order.shopId?.location?.display_name || order.shopId?.shopName || '—';

// // const formatCustomerName = (customer) => customer?.username || customer?.fullName || customer?.fullname || customer?.name || '—';

// // const formatShopName = (shop) => shop?.shopName || shop?.name || '—';

// // const formatStatus = (order) => {
// //   if (order.isExpired) return 'Expired';
// //   if (order.billingStatus === 'paid' && (order.status === 'cancelled' || order.cancelBy)) return 'Refunded';
// //   if (order.status === 'completed') return 'Completed';
// //   if (order.status === 'inprocess' || order.status === 'ongoing') return 'Pending';
// //   return 'Pending';
// // };

// // const formatAddons = (order) => {
// //   const addons = order.selectedAddOns || [];
// //   if (!addons.length) return '—';
// //   return addons.map((addon) => addon.name).filter(Boolean).join(', ') || '—';
// // };

// // const getAddonsTotal = (order) => {
// //   const fromField = safeNumber(order.addOnsTotal);
// //   if (fromField) return fromField;
// //   const addons = order.selectedAddOns || [];
// //   return addons.reduce((sum, addon) => sum + safeNumber(addon.price), 0);
// // };

// // // Resolve the actual AED discount amount for a promo code.
// // // Backend sometimes sends a precomputed top-level `discount` (AED amount) — trust that when present.
// // // Otherwise fall back to the promoCode object, which may be a flat AED amount or a percentage.
// // const getPromoValue = (order, shopPrice) => {
// //   const topLevelDiscount = safeNumber(order.discount);
// //   if (topLevelDiscount > 0) return topLevelDiscount;

// //   const promo = order.promoCode;
// //   if (!promo) return 0;

// //   const rawDiscount = safeNumber(promo.discount);
// //   const isPercentage = (promo.Discounttype || promo.discountType || '').toLowerCase() === 'percentage';
// //   if (isPercentage) {
// //     return parseFloat(((shopPrice * rawDiscount) / 100).toFixed(2));
// //   }
// //   return rawDiscount;
// // };

// // const transformOrder = (order) => {
// //   const baseShopPrice = safeNumber(order.cost || order.serviceVariant?.selectedPrice || order.serviceVariant?.basePrice);
// //   const addonsTotal = getAddonsTotal(order);
// //   // Shop price = base service price + any selected add-ons (addons are also billed to the shop)
// //   const shopPrice = parseFloat((baseShopPrice + addonsTotal).toFixed(2));
// //   const promoValue = getPromoValue(order, shopPrice);

// //   // Always compute from shopPrice — stored fee fields are often 0 or missing
// //   const commission = shopPrice * 0.08;
// //   // Customer-side platform fee: 5% of shop price, capped between AED 1.50 (min) and AED 5.00 (max)
// //   const platformFee = Math.min(5.00, Math.max(1.50, shopPrice * 0.05));
// //   // Total actually paid by the customer = shop price (incl. add-ons) − promo discount + platform fee
// //   const charged = parseFloat((shopPrice - promoValue + platformFee).toFixed(2));
// //   const stripeFee = parseFloat(((charged * 0.029) + 0.30).toFixed(2));
// //   // Promo discount is absorbed by Washta, so it comes straight out of Washta's net revenue
// //   const net = parseFloat((commission + platformFee - stripeFee - promoValue).toFixed(2));
// //   const providerEntitlement = Math.max(0, shopPrice - commission);
// //   const createdAt = order.createdAt || order.date;

// //   return {
// //     id: order.paymentId || order._id,
// //     rawId: order._id,
// //     date: formatDate(createdAt),
// //     time: formatTimeInTimezone(createdAt),
// //     createdAt: createdAt ? new Date(createdAt).toISOString() : null,
// //     provider: formatShopName(order.shopId),
// //     location: formatLocation(order),
// //     customer: formatCustomerName(order.customerId),
// //     email: order.customerId?.email || '—',
// //     vehicle: order.vehicleId?.vehicleName || order.vehicleId?.vehicleModel || order.vehicleId?.vehicleManufacturer || '—',
// //     plate: order.vehicleId?.vehiclePlateNumber || '—',
// //     carType: order.vehicleId?.vehicleType || order.vehicleId?.vehicleModel || order.vehicleId?.vehicleManufacturer || '—',
// //     service: order.serviceName || order.serviceVariant?.variantName || order.shopId?.service || '—',
// //     baseShopPrice,
// //     addonsTotal,
// //     shopPrice,
// //     promo: promoValue ? -promoValue : null,
// //     charged: charged || null,
// //     stripeFee,
// //     commission,
// //     platformFee,
// //     net,
// //     status: formatStatus(order),
// //     stripeId: order.paymentId || null,
// //     addons: formatAddons(order),
// //     promoCode: order.promoCode?.promoCode || null,
// //     promoDiscountType: (order.promoCode?.Discounttype || order.promoCode?.discountType || '').toLowerCase() || null,
// //     promoDiscountRaw: order.promoCode?.discount != null ? safeNumber(order.promoCode.discount) : null,
// //     providerEntitlement,
// //   };
// // };

// // const statusConfig = {
// //   Completed: { bg: "#d1fae5", color: "#065f46" },
// //   Refunded: { bg: "#f3f4f6", color: "#374151" },
// //   Expired: { bg: "#f3f4f6", color: "#6b7280" },
// //   Pending: { bg: "#fef3c7", color: "#92400e" },
// // };

// // function StatusPill({ status }) {
// //   const cfg = statusConfig[status] || statusConfig.Pending;
// //   return (
// //     <span
// //       style={{
// //         display: "inline-block",
// //         fontSize: 9,
// //         fontWeight: 700,
// //         padding: "2px 8px",
// //         borderRadius: 100,
// //         background: cfg.bg,
// //         color: cfg.color,
// //         whiteSpace: "nowrap",
// //       }}
// //     >
// //       {status}
// //     </span>
// //   );
// // }

// // function Plate({ text }) {
// //   return (
// //     <span
// //       style={{
// //         fontSize: 9,
// //         fontWeight: 700,
// //         background: "#fff9c4",
// //         color: "#5c4a00",
// //         border: "1px solid #ffe082",
// //         borderRadius: 4,
// //         padding: "1px 6px",
// //         fontFamily: "monospace",
// //       }}
// //     >
// //       {text}
// //     </span>
// //   );
// // }

// // function Dash() {
// //   return <span style={{ color: "#ccc", fontSize: 12 }}>—</span>;
// // }

// // function DrawerField({ label, value, color }) {
// //   return (
// //     <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
// //       <div
// //         style={{
// //           fontSize: 9,
// //           fontWeight: 700,
// //           color: "#aaa",
// //           textTransform: "uppercase",
// //           letterSpacing: "0.06em",
// //         }}
// //       >
// //         {label}
// //       </div>
// //       <div style={{ fontSize: 12, color: color || "#111", fontWeight: 600 }}>
// //         {value}
// //       </div>
// //     </div>
// //   );
// // }

// // // ─── RECEIPT MODAL ────────────────────────────────────────────────────────────
// // function ReceiptModal({ order, onClose }) {
// //   if (!order) return null;

// //   const isExpired = order.status === "Expired";
// //   const statusColor =
// //     order.status === "Completed"
// //       ? "#065f46"
// //       : order.status === "Refunded"
// //       ? "#374151"
// //       : "#6b7280";
// //   const statusBg =
// //     order.status === "Completed"
// //       ? "#d1fae5"
// //       : order.status === "Refunded"
// //       ? "#f3f4f6"
// //       : "#f3f4f6";

// //   return (
// //     <div
// //       onClick={onClose}
// //       style={{
// //         position: "fixed",
// //         inset: 0,
// //         background: "rgba(0,0,0,0.45)",
// //         zIndex: 1000,
// //         display: "flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         padding: 16,
// //         boxSizing: "border-box",
// //       }}
// //     >
// //       <div
// //         onClick={(e) => e.stopPropagation()}
// //         style={{
// //           background: "#fff",
// //           borderRadius: 14,
// //           width: "100%",
// //           maxWidth: 480,
// //           maxHeight: "90vh",
// //           overflowY: "auto",
// //           boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
// //           fontFamily: "inherit",
// //         }}
// //       >
// //         {/* Receipt Header */}
// //         <div
// //           style={{
// //             background: "#6B5FE4",
// //             borderRadius: "14px 14px 0 0",
// //             padding: "20px 22px 18px",
// //             color: "#fff",
// //             position: "relative",
// //           }}
// //         >
// //           <button
// //             onClick={onClose}
// //             style={{
// //               position: "absolute",
// //               top: 14,
// //               right: 14,
// //               background: "rgba(255,255,255,0.15)",
// //               border: "none",
// //               borderRadius: "50%",
// //               width: 28,
// //               height: 28,
// //               cursor: "pointer",
// //               color: "#fff",
// //               fontSize: 14,
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               lineHeight: 1,
// //             }}
// //           >
// //             ✕
// //           </button>
// //           <div style={{ fontSize: 11, opacity: 0.75, marginBottom: 4, letterSpacing: "0.05em" }}>
// //             WASHTA PLATFORM
// //           </div>
// //           <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 6 }}>
// //             Order Receipt
// //           </div>
// //           <div
// //             style={{
// //               fontFamily: "monospace",
// //               fontSize: 13,
// //               background: "rgba(255,255,255,0.15)",
// //               display: "inline-block",
// //               padding: "2px 10px",
// //               borderRadius: 6,
// //             }}
// //           >
// //             {getOrderNumber(order.rawId)}
// //             {/* {g} */}
// //           </div>
// //           <div style={{ marginTop: 10, fontSize: 11, opacity: 0.8 }}>
// //             {order.date} · {order.time}
// //           </div>
// //         </div>

// //         {/* Status Banner */}
// //         <div
// //           style={{
// //             background: statusBg,
// //             borderBottom: "1px solid #eee",
// //             padding: "8px 22px",
// //             display: "flex",
// //             alignItems: "center",
// //             gap: 8,
// //           }}
// //         >
// //           <span
// //             style={{
// //               width: 8,
// //               height: 8,
// //               borderRadius: "50%",
// //               background: statusColor,
// //               display: "inline-block",
// //               flexShrink: 0,
// //             }}
// //           />
// //           <span style={{ fontSize: 11, fontWeight: 700, color: statusColor }}>
// //             {order.status}
// //           </span>
// //           {order.stripeId && (
// //             <span
// //               style={{
// //                 marginLeft: "auto",
// //                 fontFamily: "monospace",
// //                 fontSize: 9,
// //                 color: "#888",
// //                 wordBreak: "break-all",
// //               }}
// //             >
// //               {order.stripeId}
// //             </span>
// //           )}
// //         </div>

// //         {/* Body */}
// //         <div style={{ padding: "18px 22px", display: "flex", flexDirection: "column", gap: 18 }}>

// //           {/* Provider + Customer */}
// //           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
// //             <ReceiptSection label="Provider">
// //               <div style={{ fontWeight: 700, fontSize: 13 }}>{order.provider}</div>
// //               <div style={{ fontSize: 11, color: "#888" }}>{order.location}</div>
// //             </ReceiptSection>
// //             <ReceiptSection label="Customer">
// //               <div style={{ fontWeight: 700, fontSize: 13 }}>{order.customer}</div>
// //               <div style={{ fontSize: 11, color: "#888" }}>{order.email}</div>
// //             </ReceiptSection>
// //           </div>

// //           {/* Vehicle */}
// //           <ReceiptSection label="Vehicle">
// //             <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
// //               <span style={{ fontWeight: 700, fontSize: 13 }}>{order.vehicle}</span>
// //               <Plate text={order.plate} />
// //               <span
// //                 style={{
// //                   fontSize: 10,
// //                   background: "#f0f0f0",
// //                   color: "#555",
// //                   borderRadius: 4,
// //                   padding: "1px 6px",
// //                   fontWeight: 600,
// //                 }}
// //               >
// //                 {order.carType}
// //               </span>
// //             </div>
// //           </ReceiptSection>

// //           {/* Service + Addons */}
// //           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
// //             <ReceiptSection label="Service">
// //               <span
// //                 style={{
// //                   fontSize: 13,
// //                   fontWeight: 700,
// //                   color: "#4a3db8",
// //                 }}
// //               >
// //                 {order.service}
// //               </span>
// //             </ReceiptSection>
// //             <ReceiptSection label="Add-ons">
// //               <span
// //                 style={{
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   color: order.addons === "—" ? "#ccc" : "#1a6641",
// //                 }}
// //               >
// //                 {order.addons}
// //               </span>
// //             </ReceiptSection>
// //           </div>

// //           {/* Promo */}
// //           {order.promoCode && (
// //             <div
// //               style={{
// //                 background: "#fffbeb",
// //                 border: "1px dashed #fbbf24",
// //                 borderRadius: 8,
// //                 padding: "8px 12px",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 gap: 8,
// //               }}
// //             >
// //               <span style={{ fontSize: 16 }}>🏷️</span>
// //               <div>
// //                 <span
// //                   style={{
// //                     fontFamily: "monospace",
// //                     fontWeight: 700,
// //                     fontSize: 12,
// //                     color: "#92400e",
// //                   }}
// //                 >
// //                   {order.promoCode}
// //                 </span>
// //                 <span style={{ fontSize: 11, color: "#92400e", marginLeft: 6 }}>
// //                   applied
// //                   {order.promoDiscountRaw != null && (
// //                     <> · {order.promoDiscountType === 'percentage'
// //                       ? `${order.promoDiscountRaw}% off`
// //                       : `AED ${order.promoDiscountRaw.toFixed(2)} off`}</>
// //                   )}
// //                   {' '}· Washta absorbed −AED {Math.abs(order.promo).toFixed(2)}
// //                 </span>
// //               </div>
// //             </div>
// //           )}

// //           {/* Financial Breakdown */}
// //           <div>
// //             <div
// //               style={{
// //                 fontSize: 9,
// //                 fontWeight: 700,
// //                 color: "#aaa",
// //                 textTransform: "uppercase",
// //                 letterSpacing: "0.06em",
// //                 marginBottom: 8,
// //               }}
// //             >
// //               Financial Breakdown
// //             </div>
// //             <div
// //               style={{
// //                 border: "1px solid #eee",
// //                 borderRadius: 10,
// //                 overflow: "hidden",
// //               }}
// //             >
// //               {[
// //                 {
// //                   label: "Base Service Price",
// //                   value: `AED ${order.baseShopPrice.toFixed(2)}`,
// //                   color: "#111",
// //                   bg: "#fff",
// //                 },
// //                 order.addonsTotal > 0 && {
// //                   label: "Add-ons Total",
// //                   value: `+AED ${order.addonsTotal.toFixed(2)}`,
// //                   color: "#1a6641",
// //                   bg: "#f0fdf4",
// //                 },
// //                 {
// //                   label: "Shop Price (incl. add-ons)",
// //                   value: `AED ${order.shopPrice.toFixed(2)}`,
// //                   color: "#111",
// //                   bg: "#f9f9f9",
// //                   bold: true,
// //                 },
// //                 order.promo != null && {
// //                   label: "Promo Discount",
// //                   value: `−AED ${Math.abs(order.promo).toFixed(2)}`,
// //                   color: "#92400e",
// //                   bg: "#fffbeb",
// //                 },
// //                 {
// //                   label: "Charged to Customer",
// //                   value: isExpired ? "—" : `AED ${order.charged?.toFixed(2)}`,
// //                   color: "#111",
// //                   bg: "#f9f9f9",
// //                   bold: true,
// //                 },
// //                 {
// //                   label: "  ↳ Washta Platform Fee (5%, capped AED 1.50–5.00) — included above",
// //                   value: isExpired
// //                     ? "—"
// //                     : `AED ${order.platformFee?.toFixed(2)}`,
// //                   color: "#4a3db8",
// //                   bg: "#f7f5ff",
// //                   italic: true,
// //                 },
// //                 {
// //                   label: "Stripe Processing Fee",
// //                   value: isExpired
// //                     ? "—"
// //                     : `−AED ${Math.abs(order.stripeFee).toFixed(2)}`,
// //                   color: "#991b1b",
// //                   bg: "#fff",
// //                 },
// //                 {
// //                   label: "Washta Commission (8%, from shop price)",
// //                   value: isExpired
// //                     ? "—"
// //                     : `+AED ${order.commission?.toFixed(2)}`,
// //                   color: "#4a3db8",
// //                   bg: "#f7f5ff",
// //                 },
// //                 {
// //                   label: "Washta Net Revenue",
// //                   value: isExpired ? "—" : `AED ${order.net?.toFixed(2)}`,
// //                   color: "#065f46",
// //                   bg: "#f0fdf4",
// //                   bold: true,
// //                 },
// //                 {
// //                   label: "Provider Entitlement",
// //                   value:
// //                     order.providerEntitlement != null
// //                       ? `AED ${order.providerEntitlement.toFixed(2)}`
// //                       : "—",
// //                   color: "#111",
// //                   bg: "#fff",
// //                 },
// //               ]
// //                 .filter(Boolean)
// //                 .map((row, i, arr) => (
// //                   <div
// //                     key={i}
// //                     style={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       alignItems: "center",
// //                       padding: "9px 13px",
// //                       background: row.bg,
// //                       borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
// //                     }}
// //                   >
// //                     <span style={{ fontSize: row.italic ? 10 : 11, color: "#555", fontStyle: row.italic ? "italic" : "normal" }}>{row.label}</span>
// //                     <span
// //                       style={{
// //                         fontSize: 12,
// //                         fontFamily: "monospace",
// //                         fontWeight: row.bold ? 800 : 600,
// //                         color: row.color,
// //                       }}
// //                     >
// //                       {row.value}
// //                     </span>
// //                   </div>
// //                 ))}
// //             </div>
// //           </div>

// //           {/* QB Note */}
// //           {order.status === "Completed" && (
// //             <div
// //               style={{
// //                 background: "#f0fdf4",
// //                 border: "1px solid #bbf7d0",
// //                 borderRadius: 8,
// //                 padding: "8px 12px",
// //                 fontSize: 10,
// //                 color: "#1a6641",
// //                 lineHeight: 1.6,
// //               }}
// //             >
// //               ✅ QB Auto-sync: Entry No.1 fired on completion · one-way to QB only
// //             </div>
// //           )}

// //           {order.status === "Expired" && (
// //             <div
// //               style={{
// //                 background: "#f0eeff",
// //                 border: "1px solid #d8d2ff",
// //                 borderRadius: 8,
// //                 padding: "8px 12px",
// //                 fontSize: 10,
// //                 color: "#4a3db8",
// //                 lineHeight: 1.6,
// //               }}
// //             >
// //               ⏱ This order expired (acceptance window timed out). No payment was taken.
// //             </div>
// //           )}

// //           {order.status === "Refunded" && (
// //             <div
// //               style={{
// //                 background: "#fff3cd",
// //                 border: "1px solid #fbbf24",
// //                 borderRadius: 8,
// //                 padding: "8px 12px",
// //                 fontSize: 10,
// //                 color: "#92400e",
// //                 lineHeight: 1.6,
// //               }}
// //             >
// //               🔄 Order refunded. QB reversal journal may be required — flag to accountant.
// //             </div>
// //           )}
// //         </div>

// //         {/* Footer */}
// //         <div
// //           style={{
// //             padding: "12px 22px 16px",
// //             borderTop: "1px solid #f0f0f0",
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //             flexWrap: "wrap",
// //             gap: 8,
// //           }}
// //         >
// //           <span style={{ fontSize: 10, color: "#aaa" }}>
// //             Generated by Washta Platform
// //           </span>
// //           <button
// //             onClick={onClose}
// //             style={{
// //               fontSize: 11,
// //               fontWeight: 600,
// //               padding: "7px 18px",
// //               background: "#6B5FE4",
// //               color: "#fff",
// //               border: "none",
// //               borderRadius: 8,
// //               cursor: "pointer",
// //             }}
// //           >
// //             Close
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // function ReceiptSection({ label, children }) {
// //   return (
// //     <div>
// //       <div
// //         style={{
// //           fontSize: 9,
// //           fontWeight: 700,
// //           color: "#aaa",
// //           textTransform: "uppercase",
// //           letterSpacing: "0.06em",
// //           marginBottom: 5,
// //         }}
// //       >
// //         {label}
// //       </div>
// //       {children}
// //     </div>
// //   );
// // }

// // // ─── XLSX EXPORT ──────────────────────────────────────────────────────────────
// // function exportToXLSX(data) {
// //   const rows = data.map((o) => ({
// //     "Order ID": o.id,
// //     "Date": o.date,
// //     "Time": o.time,
// //     "Provider": o.provider,
// //     "Location": o.location,
// //     "Customer": o.customer,
// //     "Email": o.email,
// //     "Vehicle": o.vehicle,
// //     "Plate": o.plate,
// //     "Car Type": o.carType,
// //     "Service": o.service,
// //     "Add-ons": o.addons,
// //     "Promo Code": o.promoCode || "",
// //     "Shop Price (AED)": o.shopPrice,
// //     "Promo Discount (AED)": o.promo != null ? Math.abs(o.promo) : "",
// //     "Charged to Customer (AED)": o.charged != null ? o.charged : "",
// //     "Washta Platform Fee (AED)": o.platformFee != null ? o.platformFee : "",
// //     "Stripe Fee (AED)": o.stripeFee != null ? Math.abs(o.stripeFee) : "",
// //     "Commission (AED)": o.commission != null ? o.commission : "",
// //     "Washta Net (AED)": o.net != null ? o.net : "",
// //     "Provider Entitlement (AED)": o.providerEntitlement != null ? o.providerEntitlement : "",
// //     "Status": o.status,
// //     "Stripe Payment ID": o.stripeId || "",
// //   }));

// //   const ws = XLSX.utils.json_to_sheet(rows);

// //   // Column widths
// //   ws["!cols"] = [
// //     { wch: 20 }, { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 22 },
// //     { wch: 14 }, { wch: 22 }, { wch: 18 }, { wch: 10 }, { wch: 10 },
// //     { wch: 14 }, { wch: 18 }, { wch: 12 }, { wch: 18 }, { wch: 20 },
// //     { wch: 24 }, { wch: 22 }, { wch: 18 }, { wch: 18 }, { wch: 18 },
// //     { wch: 24 }, { wch: 12 }, { wch: 32 },
// //   ];

// //   const wb = XLSX.utils.book_new();
// //   XLSX.utils.book_append_sheet(wb, ws, "All Orders");

// //   // Summary sheet
// //   const completed = data.filter((o) => o.status === "Completed");
// //   const totalCharged = completed.reduce((s, o) => s + (o.charged || 0), 0);
// //   const totalNet = completed.reduce((s, o) => s + (o.net || 0), 0);
// //   const totalCommission = completed.reduce((s, o) => s + (o.commission || 0), 0);
// //   const totalPlatformFee = completed.reduce((s, o) => s + (o.platformFee || 0), 0);
// //   const totalProviderPayout = completed.reduce((s, o) => s + (o.providerEntitlement || 0), 0);

// //   const summaryRows = [
// //     { Metric: "Total Orders", Value: data.length },
// //     { Metric: "Completed", Value: data.filter((o) => o.status === "Completed").length },
// //     { Metric: "Refunded", Value: data.filter((o) => o.status === "Refunded").length },
// //     { Metric: "Expired", Value: data.filter((o) => o.status === "Expired").length },
// //     { Metric: "" },
// //     { Metric: "Total Charged to Customers (AED)", Value: +totalCharged.toFixed(2) },
// //     { Metric: "Total Washta Commission (AED)", Value: +totalCommission.toFixed(2) },
// //     { Metric: "Total Washta Platform Fee (AED)", Value: +totalPlatformFee.toFixed(2) },
// //     { Metric: "Total Stripe Fees (AED)", Value: +data.reduce((s, o) => s + Math.abs(o.stripeFee || 0), 0).toFixed(2) },
// //     { Metric: "Total Washta Net (AED)", Value: +totalNet.toFixed(2) },
// //     { Metric: "Total Provider Payouts (AED)", Value: +totalProviderPayout.toFixed(2) },
// //   ];

// //   const ws2 = XLSX.utils.json_to_sheet(summaryRows);
// //   ws2["!cols"] = [{ wch: 38 }, { wch: 18 }];
// //   XLSX.utils.book_append_sheet(wb, ws2, "Summary");

// //   XLSX.writeFile(wb, `Washta_Orders_${new Date().toISOString().slice(0, 10)}.xlsx`);
// // }

// // // ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
// // export default function AllOrders() {
// //   const [orders, setOrders] = useState([]);
// //   const [selectedOrder, setSelectedOrder] = useState(null);
// //   const [drawerOpen, setDrawerOpen] = useState(false);
// //   const [statusFilter, setStatusFilter] = useState("All Statuses");
// //   const [providerFilter, setProviderFilter] = useState("All Providers");
// //   const [serviceFilter, setServiceFilter] = useState("All Services");
// //   const [search, setSearch] = useState("");
// //   const [refundConfirm, setRefundConfirm] = useState(false);
// //   const [refundReason, setRefundReason] = useState("");
// //   const [mobileDrawer, setMobileDrawer] = useState(false);
// //   const [receiptOrder, setReceiptOrder] = useState(null); // receipt modal
// //   const [timeFilter, setTimeFilter] = useState("Today");
// //   // NEW: custom date filter (value comes from <input type="date"> as YYYY-MM-DD)
// //   const [customDate, setCustomDate] = useState("");

// //   useEffect(() => {
// //     const fetchOrders = async () => {
// //       try {
// //         const token = localStorage.getItem("accessTokenAdmin");
// //         if (!token) return;

// //         const response = await axios.get(`${ADMIN_BASE}/orders?limit=500`, {
// //           headers: { Authorization: `Bearer ${token}` },
// //         });

// //         const rows = (response.data?.data || response.data || []).map(transformOrder);
// //         setOrders(rows);
// //         setSelectedOrder((current) => current || rows[0] || null);
// //       } catch (error) {
// //         console.error("Error fetching orders:", error);
// //       }
// //     };

// //     fetchOrders();
// //   }, []);


// // const filtered = useMemo(() => {
// //   const now = moment();
// //   let rangeStart = moment(now).startOf('day');
// //   let rangeEnd = moment(now).endOf('day');
// //   let noDateFilter = false; // NEW

// //   if (customDate) {
// //     rangeStart = moment(customDate, 'YYYY-MM-DD').startOf('day');
// //     rangeEnd = moment(customDate, 'YYYY-MM-DD').endOf('day');
// //   } else if (timeFilter === "This Week") {
// //     rangeStart = moment(now).subtract(6, 'days').startOf('day');
// //   } else if (timeFilter === "This Month") {
// //     rangeStart = moment(now).subtract(29, 'days').startOf('day');
// //   } else if (timeFilter === "All Time") { // NEW
// //     noDateFilter = true;
// //   }

// //   return orders.filter((order) => {
// //     if (!noDateFilter && order.createdAt) { // CHANGED: added !noDateFilter check
// //       const orderDate = moment.utc(order.createdAt).local();
// //       if (orderDate.isBefore(rangeStart)) return false;
// //       if (customDate && orderDate.isAfter(rangeEnd)) return false;
// //     }
// //     if (statusFilter !== "All Statuses" && order.status !== statusFilter) return false;
// //     if (providerFilter !== "All Providers" && order.provider !== providerFilter) return false;
// //     if (serviceFilter !== "All Services" && order.service !== serviceFilter) return false;
// //     if (
// //       search &&
// //       ![order.id, order.plate, order.customer, order.stripeId || ""]
// //         .join(" ")
// //         .toLowerCase()
// //         .includes(search.toLowerCase())
// //     ) {
// //       return false;
// //     }
// //     return true;
// //   });
// // }, [orders, timeFilter, customDate, statusFilter, providerFilter, serviceFilter, search]);
// //   const providerOptions = useMemo(
// //     () => ["All Providers", ...Array.from(new Set(orders.map((order) => order.provider).filter(Boolean)))],
// //     [orders]
// //   );

// //   const serviceOptions = useMemo(
// //     () => ["All Services", ...Array.from(new Set(orders.map((order) => order.service).filter(Boolean)))],
// //     [orders]
// //   );

// //   function openDrawer(order) {
// //     setSelectedOrder(order);
// //     setDrawerOpen(true);
// //     setRefundConfirm(false);
// //     setRefundReason("");
// //     setMobileDrawer(true);
// //   }

// //   return (
// //     <div
// //       className="mainDiv-all-sideBar"
// //       style={{ display: "flex", minHeight: "100vh", background: "#f0f0f5" }}
// //     >
// //       <div className="div-sidebar">
// //         <AdminSidebar />
// //       </div>

// //       <div
// //         className="div-Dashbaord"
// //         style={{
// //           flex: 1,
// //           minWidth: 0,
// //           display: "flex",
// //           flexDirection: "column",
// //           overflow: "hidden",padding:0,
// //           background:'white'
// //         }}
// //       >
// //         <div style={{ flex: 1, display: "flex", minHeight: 0, overflow: "hidden" }}>
// //           <div
// //             style={{
// //               flex: 1,
// //               minWidth: 0,
// //               overflowY: "auto",
// //               padding: "20px 20px 40px",
// //             }}
// //           >
// //            <h1 className='ws-view-title'>
// //               All Orders
// //             </h1>
// //             <p style={{ fontSize: 11, color: "#888", marginBottom: 14, lineHeight: 1.5 }}>
// //               Every transaction across all providers. Click any row to open order detail.
// //               Expired rows show full data — no money moved.
// //             </p>

// //             {/* FILTERS */}
// //             <div
// //               style={{
// //                 display: "flex",
// //                 gap: 7,
// //                 alignItems: "center",
// //                 marginBottom: 14,
// //                 flexWrap: "wrap",
// //               }}
// //             >
// //               {["Today", "This Week", "This Month", "All Time"].map((d) => (
// //   <button
// //     key={d}
// //     onClick={() => { setTimeFilter(d); setCustomDate(""); }}
// //     style={{
// //       fontSize: 10,
// //       padding: "4px 10px",
// //       border: "1px solid #ddd",
// //       borderRadius: 20,
// //       color: !customDate && timeFilter === d ? "#fff" : "#888",
// //       cursor: "pointer",
// //       background: !customDate && timeFilter === d ? "#6B5FE4" : "#fff",
// //       borderColor: !customDate && timeFilter === d ? "#6B5FE4" : "#ddd",
// //     }}
// //   >
// //     {d}
// //   </button>
// // ))}

// //               {/* NEW: Custom date picker filter (dd/mm/yyyy pill w/ calendar icon) */}
// //               <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
// //                 <input
// //                   type="date"
// //                   value={customDate}
// //                   onChange={(e) => setCustomDate(e.target.value)}
// //                   max={moment().format("YYYY-MM-DD")}
// //                   style={{
// //                     fontSize: 10,
// //                     padding: "4px 10px",
// //                     paddingRight: customDate ? 26 : 10,
// //                     border: "1px solid #ddd",
// //                     borderRadius: 20,
// //                     color: customDate ? "#fff" : "#888",
// //                     cursor: "pointer",
// //                     background: customDate ? "#6B5FE4" : "#fff",
// //                     borderColor: customDate ? "#6B5FE4" : "#ddd",
// //                     fontFamily: "inherit",
// //                     colorScheme: customDate ? "dark" : "light",
// //                     outline: "none",
// //                   }}
// //                 />
// //                 {customDate && (
// //                   <button
// //                     onClick={() => setCustomDate("")}
// //                     title="Clear date filter"
// //                     style={{
// //                       position: "absolute",
// //                       right: 6,
// //                       background: "none",
// //                       border: "none",
// //                       color: "#fff",
// //                       fontSize: 11,
// //                       lineHeight: 1,
// //                       cursor: "pointer",
// //                       padding: 0,
// //                     }}
// //                   >
// //                     ✕
// //                   </button>
// //                 )}
// //               </div>

// //               {[
// //                 {
// //                   value: providerFilter,
// //                   onChange: setProviderFilter,
// //                   options: providerOptions,
// //                 },
// //                 {
// //                   value: statusFilter,
// //                   onChange: setStatusFilter,
// //                   options: ["All Statuses", "Completed", "Refunded", "Expired"],
// //                 },
// //                 {
// //                   value: serviceFilter,
// //                   onChange: setServiceFilter,
// //                   options: serviceOptions,
// //                 },
// //               ].map(({ value, onChange, options }, i) => (
// //                 <select
// //                   key={i}
// //                   value={value}
// //                   onChange={(e) => onChange(e.target.value)}
// //                   style={{
// //                     fontSize: 11,
// //                     color: "#111",
// //                     border: "1px solid #ddd",
// //                     borderRadius: 7,
// //                     padding: "5px 8px",
// //                     background: "#fff",
// //                     fontFamily: "inherit",
// //                   }}
// //                 >
// //                   {options.map((o) => (
// //                     <option key={o}>{o}</option>
// //                   ))}
// //                 </select>
// //               ))}
// //               <input
// //                 value={search}
// //                 onChange={(e) => setSearch(e.target.value)}
// //                 placeholder="Order ID, plate, customer, Stripe ID…"
// //                 style={{
// //                   fontSize: 11,
// //                   border: "1px solid #ddd",
// //                   borderRadius: 7,
// //                   padding: "5px 9px",
// //                   background: "#fff",
// //                   color: "#111",
// //                   fontFamily: "inherit",
// //                   width: 200,
// //                   marginLeft: "auto",
// //                 }}
// //               />
// //               {/* ↓ EXPORT BUTTON */}
// //               <button
// //                 onClick={() => exportToXLSX(filtered)}
// //                 style={{
// //                   fontSize: 10,
// //                   fontWeight: 600,
// //                   padding: "5px 11px",
// //                   borderRadius: 7,
// //                   cursor: "pointer",
// //                   background: "#fff",
// //                   color: "#111",
// //                   border: "1px solid #ddd",
// //                   display: "flex",
// //                   alignItems: "center",
// //                   gap: 4,
// //                 }}
// //               >
// //                 ↓ Export
// //               </button>
// //             </div>

// //             {/* TABLE */}
// //             <div style={{ overflowX: "auto" }}>
// //               <table
// //                 style={{
// //                   width: "100%",
// //                   borderCollapse: "collapse",
// //                   minWidth: 900,
// //                 }}
// //               >
// //                 <thead>
// //                   <tr>
// //                     {[
// //                       "Order ID",
// //                       "Date / Time",
// //                       "Provider · Location",
// //                       "Customer",
// //                       "Vehicle",
// //                       "Service",
// //                       "Shop Price",
// //                       "Promo",
// //                       "Charged",
// //                       "Stripe Fee",
// //                       "Commission",
// //                       "Net",
// //                       "Status",
// //                     ].map((h, i) => (
// //                       <th
// //                         key={h}
// //                         style={{
// //                           fontSize: 9,
// //                           fontWeight: 700,
// //                           color: "#aaa",
// //                           textTransform: "uppercase",
// //                           letterSpacing: "0.06em",
// //                           padding: "7px 10px",
// //                           textAlign: i >= 6 && i <= 11 ? "right" : "left",
// //                           borderBottom: "1.5px solid #eee",
// //                           background: "#f7f7f9",
// //                           whiteSpace: "nowrap",
// //                         }}
// //                       >
// //                         {h}
// //                       </th>
// //                     ))}
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {filtered.map((order) => {
// //                     const isExpired = order.status === "Expired";
// //                     const isRefunded = order.status === "Refunded";
// //                     const isSelected = selectedOrder?.id === order.id && drawerOpen;
// //                     return (
// //                       <tr
// //                         key={order.id}
// //                         onClick={() => openDrawer(order)}
// //                         style={{
// //                           cursor: "pointer",
// //                           background: isRefunded
// //                             ? "#fffbeb"
// //                             : isSelected
// //                             ? "#f0eeff"
// //                             : "transparent",
// //                           transition: "background 0.1s",
// //                         }}
// //                         onMouseEnter={(e) => {
// //                           if (!isSelected) e.currentTarget.style.background = "#fafafa";
// //                         }}
// //                         onMouseLeave={(e) => {
// //                           e.currentTarget.style.background = isRefunded
// //                             ? "#fffbeb"
// //                             : isSelected
// //                             ? "#f0eeff"
// //                             : "transparent";
// //                         }}
// //                       >
// //                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
// //                           <div
// //                             style={{
// //                               fontSize: 10,
// //                               color: "#6B5FE4",
// //                               fontFamily: "monospace",
// //                               fontWeight: 600,
// //                             }}
// //                           >
// //                             {getOrderNumber(order?.rawId)}
                            
// //                           </div>
// //                         </td>
// //                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
// //                           <div style={{ fontSize: 11 }}>{order.date}</div>
// //                           <div style={{ fontSize: 10, color: "#aaa" }}>{order.time}</div>
// //                         </td>
// //                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
// //                           <div style={{ fontWeight: 700, fontSize: 11 }}>{order.provider}</div>
// //                           <div style={{ fontSize: 10, color: "#888" }}>{order.location}</div>
// //                         </td>
// //                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
// //                           <div style={{ fontSize: 11 }}>{order.customer}</div>
// //                           <div style={{ fontSize: 10, color: "#aaa" }}>{order.email}</div>
// //                         </td>
// //                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
// //                           <div style={{ fontSize: 11 }}>{order.vehicle}</div>
// //                           <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
// //                             <Plate text={order.plate} />
// //                             <span style={{ fontSize: 9, color: "#888" }}>{order.carType}</span>
// //                           </div>
// //                         </td>
// //                         <td
// //                           style={{
// //                             padding: "8px 10px",
// //                             borderBottom: "1px solid #f5f5f5",
// //                             fontSize: 11,
// //                             color: isExpired ? "#aaa" : "#4a3db8",
// //                             fontWeight: 600,
// //                           }}
// //                         >
// //                           {order.service}
// //                         </td>
// //                         <td
// //                           style={{
// //                             padding: "8px 10px",
// //                             borderBottom: "1px solid #f5f5f5",
// //                             textAlign: "right",
// //                             fontSize: 11,
// //                             fontFamily: "monospace",
// //                           }}
// //                         >
// //                           AED {order.shopPrice.toFixed(2)}
// //                         </td>
// //                         <td
// //                           style={{
// //                             padding: "8px 10px",
// //                             borderBottom: "1px solid #f5f5f5",
// //                             textAlign: "right",
// //                             fontSize: 11,
// //                             fontFamily: "monospace",
// //                             color: "#92400e",
// //                           }}
// //                         >
// //                           {order.promo ? `−${Math.abs(order.promo).toFixed(2)}` : <Dash />}
// //                         </td>
// //                         <td
// //                           style={{
// //                             padding: "8px 10px",
// //                             borderBottom: "1px solid #f5f5f5",
// //                             textAlign: "right",
// //                             fontSize: 11,
// //                             fontFamily: "monospace",
// //                           }}
// //                         >
// //                           {isExpired ? <Dash /> : order.charged?.toFixed(2)}
// //                         </td>
// //                         <td
// //                           style={{
// //                             padding: "8px 10px",
// //                             borderBottom: "1px solid #f5f5f5",
// //                             textAlign: "right",
// //                             fontSize: 11,
// //                             fontFamily: "monospace",
// //                             color: "#991b1b",
// //                           }}
// //                         >
// //                           {isExpired ? <Dash /> : `−${Math.abs(order.stripeFee).toFixed(2)}`}
// //                         </td>
// //                         <td
// //                           style={{
// //                             padding: "8px 10px",
// //                             borderBottom: "1px solid #f5f5f5",
// //                             textAlign: "right",
// //                             fontSize: 11,
// //                             fontFamily: "monospace",
// //                             color: "#4a3db8",
// //                           }}
// //                         >
// //                           {isExpired ? <Dash /> : order.commission != null ? `+${order.commission.toFixed(2)}` : <Dash />}
// //                         </td>
// //                         <td
// //                           style={{
// //                             padding: "8px 10px",
// //                             borderBottom: "1px solid #f5f5f5",
// //                             textAlign: "right",
// //                             fontSize: 11,
// //                             fontFamily: "monospace",
// //                             fontWeight: 700,
// //                           }}
// //                         >
// //                           {isExpired ? <Dash /> : order.net != null ? order.net.toFixed(2) : <Dash />}
// //                         </td>
// //                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
// //                           <StatusPill status={order.status} />
// //                         </td>
// //                       </tr>
// //                     );
// //                   })}
// //                 </tbody>
// //               </table>
// //             </div>

// //             <div
// //               style={{
// //                 fontSize: 11,
// //                 color: "#888",
// //                 marginTop: 10,
// //                 paddingTop: 10,
// //                 borderTop: "1px solid #f0f0f0",
// //               }}
// //             >
// //               Showing {filtered.length} of {orders.length}
// //               {customDate && (
// //                 <> · Date: <strong>{moment(customDate, "YYYY-MM-DD").format("DD/MM/YYYY")}</strong></>
// //               )}
// //               {" "}
// //               {/* <span style={{ color: "#6B5FE4", cursor: "pointer" }}>Load more →</span> */}
// //             </div>
// //           </div>

// //           {/* RIGHT DRAWER PANEL (desktop) */}
// //           {drawerOpen && selectedOrder && (
// //             <div
// //               style={{
// //                 width: 320,
// //                 flexShrink: 0,
// //                 borderLeft: "1px solid #eee",
// //                 overflowY: "auto",
// //                 background: "#fff",
// //               }}
// //             >
// //               {/* Drawer Header */}
// //               <div
// //                 style={{
// //                   background: "#f7f7f9",
// //                   borderBottom: "1px solid #eee",
// //                   padding: "10px 14px",
// //                   display: "flex",
// //                   alignItems: "center",
// //                   justifyContent: "space-between",
// //                   position: "sticky",
// //                   top: 0,
// //                   zIndex: 1,
// //                 }}
// //               >
// //                 <div>
// //                   <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>
// //                     Order Detail
// //                   </div>
// //                   <div
// //                     style={{
// //                       fontSize: 10,
// //                       color: "#6B5FE4",
// //                       fontFamily: "monospace",
// //                       marginTop: 2,
// //                     }}
// //                   >
// //                      {getOrderNumber(selectedOrder?.rawId)}

// //                     {/* {selectedOrder.id} */}
// //                   </div>
// //                 </div>
// //                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// //                   <StatusPill status={selectedOrder.status} />
// //                   <button
// //                     onClick={() => { setDrawerOpen(false); setMobileDrawer(false); }}
// //                     style={{
// //                       fontSize: 16,
// //                       background: "none",
// //                       border: "none",
// //                       cursor: "pointer",
// //                       color: "#888",
// //                       lineHeight: 1,
// //                       padding: "0 4px",
// //                     }}
// //                   >
// //                     ✕
// //                   </button>
// //                 </div>
// //               </div>

// //               {/* Drawer Body */}
// //               <div
// //                 style={{
// //                   padding: 14,
// //                   display: "grid",
// //                   gridTemplateColumns: "1fr 1fr",
// //                   gap: 14,
// //                 }}
// //               >
// //                 <DrawerField
// //                   label="Washta Order ID"
// //                   value={
// //                     <span style={{ fontFamily: "monospace", fontSize: 11, color: "#6B5FE4" }}>
// //                       {/* {selectedOrder.id} */}
// //                     {getOrderNumber(selectedOrder?.rawId)}

// //                     </span>
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Date / Time"
// //                   value={`${selectedOrder.date} · ${selectedOrder.time}`}
// //                 />
// //                 <div style={{ gridColumn: "1 / -1" }}>
// //                   <DrawerField
// //                     label="Stripe Payment ID"
// //                     value={
// //                       selectedOrder.stripeId ? (
// //                         <span style={{ fontFamily: "monospace", fontSize: 10, color: "#111" }}>
// //                           {selectedOrder.stripeId}
// //                         </span>
// //                       ) : (
// //                         <span style={{ color: "#aaa", fontSize: 11 }}>— not charged</span>
// //                       )
// //                     }
// //                   />
// //                 </div>
// //                 <DrawerField
// //                   label="Provider · Location"
// //                   value={`${selectedOrder.provider} · ${selectedOrder.location}`}
// //                 />
// //                 <DrawerField
// //                   label="Customer"
// //                   value={`${selectedOrder.customer} · ${selectedOrder.email}`}
// //                 />
// //                 <DrawerField
// //                   label="Vehicle"
// //                   value={
// //                     <span>
// //                       {selectedOrder.vehicle} · <Plate text={selectedOrder.plate} /> ·{" "}
// //                       {selectedOrder.carType}
// //                     </span>
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Service"
// //                   value={<span style={{ color: "#4a3db8" }}>{selectedOrder.service}</span>}
// //                 />
// //                 <DrawerField
// //                   label="Add-ons"
// //                   value={<span style={{ color: "#1a6641" }}>{selectedOrder.addons}</span>}
// //                 />
// //                 <DrawerField
// //                   label="Promo Code"
// //                   value={
// //                     selectedOrder.promoCode
// //                       ? `${selectedOrder.promoCode}${selectedOrder.promoDiscountRaw != null ? ` · ${selectedOrder.promoDiscountType === 'percentage' ? `${selectedOrder.promoDiscountRaw}% off` : `AED ${selectedOrder.promoDiscountRaw.toFixed(2)} off`}` : ''} · −AED ${Math.abs(selectedOrder.promo).toFixed(2)} · Washta absorbed`
// //                       : "None"
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Base Service Price"
// //                   value={`AED ${selectedOrder.baseShopPrice.toFixed(2)}`}
// //                 />
// //                 <DrawerField
// //                   label="Add-ons Total"
// //                   value={
// //                     selectedOrder.addonsTotal > 0
// //                       ? <span style={{ color: "#1a6641" }}>+AED {selectedOrder.addonsTotal.toFixed(2)}</span>
// //                       : "—"
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Shop Price (incl. add-ons)"
// //                   value={`AED ${selectedOrder.shopPrice.toFixed(2)}`}
// //                 />
// //                 <DrawerField
// //                   label="Charged to Customer"
// //                   value={
// //                     selectedOrder.charged != null
// //                       ? `AED ${selectedOrder.charged.toFixed(2)}`
// //                       : "—"
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Platform Fee (5%, capped 1.50–5.00) — incl. in charged"
// //                   value={
// //                     selectedOrder.platformFee != null ? (
// //                       <span style={{ color: "#4a3db8" }}>
// //                         AED {selectedOrder.platformFee.toFixed(2)}
// //                       </span>
// //                     ) : (
// //                       "—"
// //                     )
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Stripe Fee"
// //                   value={
// //                     selectedOrder.stripeFee != null ? (
// //                       <span style={{ color: "#991b1b" }}>
// //                         − AED {Math.abs(selectedOrder.stripeFee).toFixed(2)}
// //                       </span>
// //                     ) : (
// //                       "—"
// //                     )
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Commission (8% shop price)"
// //                   value={
// //                     selectedOrder.commission != null ? (
// //                       <span style={{ color: "#4a3db8" }}>
// //                         + AED {selectedOrder.commission.toFixed(2)}
// //                       </span>
// //                     ) : (
// //                       "—"
// //                     )
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Washta Net"
// //                   value={
// //                     selectedOrder.net != null ? (
// //                       <span style={{ color: "#1a6641" }}>
// //                         AED {selectedOrder.net.toFixed(2)}
// //                       </span>
// //                     ) : (
// //                       "—"
// //                     )
// //                   }
// //                 />
// //                 <DrawerField
// //                   label="Provider Entitlement"
// //                   value={
// //                     selectedOrder.providerEntitlement != null
// //                       ? `AED ${selectedOrder.providerEntitlement.toFixed(2)}`
// //                       : "—"
// //                   }
// //                 />
// //                 <div style={{ gridColumn: "1 / -1" }}>
// //                   <DrawerField
// //                     label="QB Auto-sync"
// //                     value={
// //                       selectedOrder.status === "Completed" ? (
// //                         <span style={{ fontSize: 11, color: "#1a6641" }}>
// //                           Entry No.1 fired on completion · one-way to QB only
// //                         </span>
// //                       ) : (
// //                         <span style={{ fontSize: 11, color: "#aaa" }}>— not applicable</span>
// //                       )
// //                     }
// //                   />
// //                 </div>
// //               </div>

// //               {/* Drawer Actions */}
// //               <div
// //                 style={{
// //                   padding: "12px 14px",
// //                   background: "#fafafa",
// //                   borderTop: "1px solid #eee",
// //                   display: "flex",
// //                   alignItems: "center",
// //                   justifyContent: "space-between",
// //                   gap: 8,
// //                 }}
// //               >
// //                 {/* VIEW RECEIPT — opens modal */}
// //                 <button
// //                   onClick={() => setReceiptOrder(selectedOrder)}
// //                   style={{
// //                     fontSize: 10,
// //                     fontWeight: 600,
// //                     padding: "6px 14px",
// //                     background: "#fff",
// //                     color: "#6B5FE4",
// //                     border: "1px solid #d8d2ff",
// //                     borderRadius: 7,
// //                     cursor: "pointer",
// //                   }}
// //                 >
// //                   View Receipt
// //                 </button>
// //                 {selectedOrder.status === "Completed" && (
// //                   <button
// //                     onClick={() => setRefundConfirm(true)}
// //                     style={{
// //                       fontSize: 10,
// //                       fontWeight: 700,
// //                       padding: "6px 14px",
// //                       background: "#fee2e2",
// //                       color: "#991b1b",
// //                       border: "1px solid #fca5a5",
// //                       borderRadius: 7,
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     🚩 Flag for Refund
// //                   </button>
// //                 )}
// //               </div>

// //               {/* Refund Confirm */}
// //               {refundConfirm && (
// //                 <div style={{ padding: "10px 14px 14px" }}>
// //                   <div
// //                     style={{
// //                       background: "#fff3cd",
// //                       border: "1px solid #fbbf24",
// //                       borderRadius: 8,
// //                       padding: "10px 12px",
// //                       marginBottom: 10,
// //                       fontSize: 10,
// //                       color: "#92400e",
// //                       lineHeight: 1.6,
// //                     }}
// //                   >
// //                     ⚠️ This will mark order as Refunded, notify customer, and log an audit entry.
// //                     Actual Stripe refund must be processed separately in Stripe Dashboard.
// //                   </div>
// //                   <textarea
// //                     value={refundReason}
// //                     onChange={(e) => setRefundReason(e.target.value)}
// //                     placeholder="Reason for refund (required)…"
// //                     rows={3}
// //                     style={{
// //                       width: "100%",
// //                       fontSize: 11,
// //                       border: "1px solid #ddd",
// //                       borderRadius: 7,
// //                       padding: "7px 9px",
// //                       fontFamily: "inherit",
// //                       resize: "vertical",
// //                       marginBottom: 8,
// //                       boxSizing: "border-box",
// //                     }}
// //                   />
// //                   <div style={{ display: "flex", gap: 8 }}>
// //                     <button
// //                       onClick={() => setRefundConfirm(false)}
// //                       style={{
// //                         flex: 1,
// //                         fontSize: 10,
// //                         fontWeight: 600,
// //                         padding: "6px 0",
// //                         background: "#fff",
// //                         color: "#666",
// //                         border: "1px solid #ddd",
// //                         borderRadius: 7,
// //                         cursor: "pointer",
// //                       }}
// //                     >
// //                       Cancel
// //                     </button>
// //                     <button
// //                       disabled={!refundReason.trim()}
// //                       style={{
// //                         flex: 2,
// //                         fontSize: 10,
// //                         fontWeight: 700,
// //                         padding: "6px 0",
// //                         background: refundReason.trim() ? "#fee2e2" : "#f3f4f6",
// //                         color: refundReason.trim() ? "#991b1b" : "#aaa",
// //                         border: `1px solid ${refundReason.trim() ? "#fca5a5" : "#eee"}`,
// //                         borderRadius: 7,
// //                         cursor: refundReason.trim() ? "pointer" : "not-allowed",
// //                       }}
// //                     >
// //                       Confirm Refund Flag
// //                     </button>
// //                   </div>
// //                 </div>
// //               )}

// //               {selectedOrder.status !== "Completed" && (
// //                 <div
// //                   style={{
// //                     margin: "0 14px 14px",
// //                     background: "#f0eeff",
// //                     border: "1px solid #d8d2ff",
// //                     borderRadius: 8,
// //                     padding: "8px 12px",
// //                     fontSize: 10,
// //                     color: "#4a3db8",
// //                     lineHeight: 1.5,
// //                   }}
// //                 >
// //                   {selectedOrder.status === "Expired"
// //                     ? "This order expired (acceptance window timed out). No payment was taken — no financial impact."
// //                     : "This order has already been refunded. QB reversal journal may be required — flag to accountant."}
// //                 </div>
// //               )}
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       {/* RECEIPT MODAL */}
// //       {receiptOrder && (
// //         <ReceiptModal order={receiptOrder} onClose={() => setReceiptOrder(null)} />
// //       )}

// //       <style>{`
// //         @media (max-width: 768px) {
// //           .mainDiv-all-sideBar {
// //             flex-direction: column;
// //           }
// //           .div-sidebar {
// //             width: 100% !important;
// //           }
// //         }
// //       `}</style>
// //     </div>
// //   );
// // }
// import AdminSidebar from "admin/sidebar/AdminSidebar";
// import { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import { getReadableOrderId } from "pages/utils/HelperFun";
// import moment from "moment";
// import { formatDate, formatTimeInTimezone } from "pages/utils/formdatedynamics";

// const API_BASE = process.env.REACT_APP_API_URL || "https://backend.washta.com";
// const ADMIN_BASE = `${API_BASE}/api/admin`;

// const safeNumber = (value) => {
//   const parsed = Number(value ?? 0);
//   return Number.isFinite(parsed) ? parsed : 0;
// };

// const getOrderNumber = (data, prefix = "WS") => {
//   const id = typeof data === "string" ? data : data?._id || data?.id;
//   if (!id) return `${prefix}-—`;
//   return getReadableOrderId(String(id), prefix);
// };

// const formatLocation = (order) =>
//   order.serviceLocation?.text ||
//   order.shopLocationText ||
//   order.shopId?.location?.text ||
//   order.shopId?.location?.display_name ||
//   order.shopId?.shopName ||
//   "—";

// const formatCustomerName = (customer) =>
//   customer?.username ||
//   customer?.fullName ||
//   customer?.fullname ||
//   customer?.name ||
//   "—";

// const formatShopName = (shop) => shop?.shopName || shop?.name || "—";

// const formatStatus = (order) => {
//   const status = String(order.status || "").toLowerCase();
//   const cancelBy = String(order.cancelBy || order.cancelledBy || "").toLowerCase();

//   if (order.isRefunded === true) return "Refunded";
//   if (order.isExpired === true) return "Expired";

//   if (
//     order.isCancel === true ||
//     status === "cancelled" ||
//     cancelBy === "seller" ||
//     cancelBy === "shop" ||
//     cancelBy === "provider"
//   ) {
//     return "Cancelled";
//   }

//   if (status === "completed") return "Completed";
//   if (status === "inprocess" || status === "ongoing") return "Pending";

//   return "Pending";
// };

// const getStatusReason = (order) => {
//   const status = formatStatus(order);

//   if (status === "Refunded") return "Admin refunded this order.";
//   if (status === "Expired") {
//     return "System expired this order after 12 hours without seller acceptance.";
//   }
//   if (status === "Cancelled") return "Seller cancelled this order.";

//   return "";
// };

// const canRefundOrder = (order) => {
//   if (!order) return false;
//   if (order.status === "Refunded") return false;
//   if (order.status === "Expired") return false;

//   return Boolean(order.stripeId || order.paymentId || order.charged);
// };

// const formatAddons = (order) => {
//   const addons = order.selectedAddOns || [];
//   if (!addons.length) return "—";
//   return addons.map((addon) => addon.name).filter(Boolean).join(", ") || "—";
// };

// const getAddonsTotal = (order) => {
//   const fromField = safeNumber(order.addOnsTotal);
//   if (fromField) return fromField;

//   const addons = order.selectedAddOns || [];
//   return addons.reduce((sum, addon) => sum + safeNumber(addon.price), 0);
// };

// const getPromoValue = (order, shopPrice) => {
//   const topLevelDiscount = safeNumber(order.discount);
//   if (topLevelDiscount > 0) return topLevelDiscount;

//   const promo = order.promoCode;
//   if (!promo) return 0;

//   const rawDiscount = safeNumber(promo.discount);
//   const isPercentage =
//     String(promo.Discounttype || promo.discountType || "").toLowerCase() === "percentage";

//   if (isPercentage) {
//     return parseFloat(((shopPrice * rawDiscount) / 100).toFixed(2));
//   }

//   return rawDiscount;
// };

// const transformOrder = (order) => {
//   const baseShopPrice = safeNumber(
//     order.cost || order.serviceVariant?.selectedPrice || order.serviceVariant?.basePrice
//   );

//   const addonsTotal = getAddonsTotal(order);
//   const shopPrice = parseFloat((baseShopPrice + addonsTotal).toFixed(2));
//   const promoValue = getPromoValue(order, shopPrice);

//   const commission = shopPrice * 0.08;
//   const platformFee = Math.min(5.0, Math.max(1.5, shopPrice * 0.05));
//   const charged = parseFloat((shopPrice - promoValue + platformFee).toFixed(2));
//   const stripeFee = parseFloat((charged * 0.029 + 0.3).toFixed(2));
//   const net = parseFloat((commission + platformFee - stripeFee - promoValue).toFixed(2));
//   const providerEntitlement = Math.max(0, shopPrice - commission);

//   const createdAt = order.createdAt || order.date;
//   const readableOrderId = getOrderNumber(order._id);
//   const status = formatStatus(order);

//   return {
//     id: order.paymentId || order._id,
//     rawId: order._id,
//     readableOrderId,

//     date: formatDate(createdAt),
//     time: formatTimeInTimezone(createdAt),
//     createdAt: createdAt ? new Date(createdAt).toISOString() : null,

//     provider: formatShopName(order.shopId),
//     location: formatLocation(order),
//     customer: formatCustomerName(order.customerId),
//     email: order.customerId?.email || "—",

//     vehicle:
//       order.vehicleId?.vehicleName ||
//       order.vehicleId?.vehicleModel ||
//       order.vehicleId?.vehicleManufacturer ||
//       "—",
//     plate: order.vehicleId?.vehiclePlateNumber || "—",
//     carType:
//       order.vehicleId?.vehicleType ||
//       order.vehicleId?.vehicleModel ||
//       order.vehicleId?.vehicleManufacturer ||
//       "—",

//     service: order.serviceName || order.serviceVariant?.variantName || order.shopId?.service || "—",

//     baseShopPrice,
//     addonsTotal,
//     shopPrice,
//     promo: promoValue ? -promoValue : null,
//     charged: charged || null,
//     stripeFee,
//     commission,
//     platformFee,
//     net,
//     providerEntitlement,

//     status,
//     statusReason: getStatusReason(order),

//     isRefunded: order.isRefunded === true,
//     isExpired: order.isExpired === true,
//     isCancelledBySeller: status === "Cancelled",

//     refundReason: order.refundReason || order.refundedReason || "",
//     refundedAt: order.refundedAt || null,
//     cancelBy: order.cancelBy || order.cancelledBy || null,

//     stripeId: order.paymentId || null,
//     addons: formatAddons(order),

//     promoCode: order.promoCode?.promoCode || null,
//     promoDiscountType:
//       String(order.promoCode?.Discounttype || order.promoCode?.discountType || "").toLowerCase() ||
//       null,
//     promoDiscountRaw:
//       order.promoCode?.discount != null ? safeNumber(order.promoCode.discount) : null,
//   };
// };

// const statusConfig = {
//   Completed: { bg: "#d1fae5", color: "#065f46" },
//   Refunded: { bg: "#fee2e2", color: "#991b1b" },
//   Cancelled: { bg: "#fee2e2", color: "#991b1b" },
//   Expired: { bg: "#eef2ff", color: "#4338ca" },
//   Pending: { bg: "#fef3c7", color: "#92400e" },
// };

// function StatusPill({ status }) {
//   const cfg = statusConfig[status] || statusConfig.Pending;

//   return (
//     <span
//       style={{
//         display: "inline-block",
//         fontSize: 9,
//         fontWeight: 700,
//         padding: "2px 8px",
//         borderRadius: 100,
//         background: cfg.bg,
//         color: cfg.color,
//         whiteSpace: "nowrap",
//       }}
//     >
//       {status}
//     </span>
//   );
// }

// function Plate({ text }) {
//   return (
//     <span
//       style={{
//         fontSize: 9,
//         fontWeight: 700,
//         background: "#fff9c4",
//         color: "#5c4a00",
//         border: "1px solid #ffe082",
//         borderRadius: 4,
//         padding: "1px 6px",
//         fontFamily: "monospace",
//       }}
//     >
//       {text}
//     </span>
//   );
// }

// function Dash() {
//   return <span style={{ color: "#ccc", fontSize: 12 }}>—</span>;
// }

// function DrawerField({ label, value, color }) {
//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
//       <div
//         style={{
//           fontSize: 9,
//           fontWeight: 700,
//           color: "#aaa",
//           textTransform: "uppercase",
//           letterSpacing: "0.06em",
//         }}
//       >
//         {label}
//       </div>
//       <div style={{ fontSize: 12, color: color || "#111", fontWeight: 600 }}>{value}</div>
//     </div>
//   );
// }

// function ReceiptSection({ label, children }) {
//   return (
//     <div>
//       <div
//         style={{
//           fontSize: 9,
//           fontWeight: 700,
//           color: "#aaa",
//           textTransform: "uppercase",
//           letterSpacing: "0.06em",
//           marginBottom: 5,
//         }}
//       >
//         {label}
//       </div>
//       {children}
//     </div>
//   );
// }

// function ReceiptModal({ order, onClose }) {
//   if (!order) return null;

//   const isExpired = order.status === "Expired";
//   const statusStyle = statusConfig[order.status] || statusConfig.Pending;

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.45)",
//         zIndex: 1000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 16,
//         boxSizing: "border-box",
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           background: "#fff",
//           borderRadius: 14,
//           width: "100%",
//           maxWidth: 480,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
//           fontFamily: "inherit",
//         }}
//       >
//         <div
//           style={{
//             background: "#6B5FE4",
//             borderRadius: "14px 14px 0 0",
//             padding: "20px 22px 18px",
//             color: "#fff",
//             position: "relative",
//           }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               position: "absolute",
//               top: 14,
//               right: 14,
//               background: "rgba(255,255,255,0.15)",
//               border: "none",
//               borderRadius: "50%",
//               width: 28,
//               height: 28,
//               cursor: "pointer",
//               color: "#fff",
//               fontSize: 14,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               lineHeight: 1,
//             }}
//           >
//             ✕
//           </button>

//           <div style={{ fontSize: 11, opacity: 0.75, marginBottom: 4, letterSpacing: "0.05em" }}>
//             WASHTA PLATFORM
//           </div>

//           <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 6 }}>Order Receipt</div>

//           <div
//             style={{
//               fontFamily: "monospace",
//               fontSize: 13,
//               background: "rgba(255,255,255,0.15)",
//               display: "inline-block",
//               padding: "2px 10px",
//               borderRadius: 6,
//             }}
//           >
//             {order.readableOrderId || getOrderNumber(order.rawId)}
//           </div>

//           <div style={{ marginTop: 10, fontSize: 11, opacity: 0.8 }}>
//             {order.date} · {order.time}
//           </div>
//         </div>

//         <div
//           style={{
//             background: statusStyle.bg,
//             borderBottom: "1px solid #eee",
//             padding: "8px 22px",
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//           }}
//         >
//           <span
//             style={{
//               width: 8,
//               height: 8,
//               borderRadius: "50%",
//               background: statusStyle.color,
//               display: "inline-block",
//               flexShrink: 0,
//             }}
//           />
//           <span style={{ fontSize: 11, fontWeight: 700, color: statusStyle.color }}>
//             {order.status}
//             {order.statusReason ? ` · ${order.statusReason}` : ""}
//           </span>

//           {order.stripeId && (
//             <span
//               style={{
//                 marginLeft: "auto",
//                 fontFamily: "monospace",
//                 fontSize: 9,
//                 color: "#888",
//                 wordBreak: "break-all",
//               }}
//             >
//               {order.stripeId}
//             </span>
//           )}
//         </div>

//         <div style={{ padding: "18px 22px", display: "flex", flexDirection: "column", gap: 18 }}>
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
//             <ReceiptSection label="Provider">
//               <div style={{ fontWeight: 700, fontSize: 13 }}>{order.provider}</div>
//               <div style={{ fontSize: 11, color: "#888" }}>{order.location}</div>
//             </ReceiptSection>

//             <ReceiptSection label="Customer">
//               <div style={{ fontWeight: 700, fontSize: 13 }}>{order.customer}</div>
//               <div style={{ fontSize: 11, color: "#888" }}>{order.email}</div>
//             </ReceiptSection>
//           </div>

//           <ReceiptSection label="Vehicle">
//             <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
//               <span style={{ fontWeight: 700, fontSize: 13 }}>{order.vehicle}</span>
//               <Plate text={order.plate} />
//               <span
//                 style={{
//                   fontSize: 10,
//                   background: "#f0f0f0",
//                   color: "#555",
//                   borderRadius: 4,
//                   padding: "1px 6px",
//                   fontWeight: 600,
//                 }}
//               >
//                 {order.carType}
//               </span>
//             </div>
//           </ReceiptSection>

//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
//             <ReceiptSection label="Service">
//               <span style={{ fontSize: 13, fontWeight: 700, color: "#4a3db8" }}>
//                 {order.service}
//               </span>
//             </ReceiptSection>

//             <ReceiptSection label="Add-ons">
//               <span
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 600,
//                   color: order.addons === "—" ? "#ccc" : "#1a6641",
//                 }}
//               >
//                 {order.addons}
//               </span>
//             </ReceiptSection>
//           </div>

//           {order.promoCode && (
//             <div
//               style={{
//                 background: "#fffbeb",
//                 border: "1px dashed #fbbf24",
//                 borderRadius: 8,
//                 padding: "8px 12px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//             >
//               <span style={{ fontSize: 16 }}>🏷️</span>
//               <div>
//                 <span
//                   style={{
//                     fontFamily: "monospace",
//                     fontWeight: 700,
//                     fontSize: 12,
//                     color: "#92400e",
//                   }}
//                 >
//                   {order.promoCode}
//                 </span>
//                 <span style={{ fontSize: 11, color: "#92400e", marginLeft: 6 }}>
//                   applied
//                   {order.promoDiscountRaw != null && (
//                     <>
//                       {" "}
//                       ·{" "}
//                       {order.promoDiscountType === "percentage"
//                         ? `${order.promoDiscountRaw}% off`
//                         : `AED ${order.promoDiscountRaw.toFixed(2)} off`}
//                     </>
//                   )}{" "}
//                   · Washta absorbed −AED {Math.abs(order.promo).toFixed(2)}
//                 </span>
//               </div>
//             </div>
//           )}

//           <div>
//             <div
//               style={{
//                 fontSize: 9,
//                 fontWeight: 700,
//                 color: "#aaa",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.06em",
//                 marginBottom: 8,
//               }}
//             >
//               Financial Breakdown
//             </div>

//             <div style={{ border: "1px solid #eee", borderRadius: 10, overflow: "hidden" }}>
//               {[
//                 {
//                   label: "Base Service Price",
//                   value: `AED ${order.baseShopPrice.toFixed(2)}`,
//                   color: "#111",
//                   bg: "#fff",
//                 },
//                 order.addonsTotal > 0 && {
//                   label: "Add-ons Total",
//                   value: `+AED ${order.addonsTotal.toFixed(2)}`,
//                   color: "#1a6641",
//                   bg: "#f0fdf4",
//                 },
//                 {
//                   label: "Shop Price (incl. add-ons)",
//                   value: `AED ${order.shopPrice.toFixed(2)}`,
//                   color: "#111",
//                   bg: "#f9f9f9",
//                   bold: true,
//                 },
//                 order.promo != null && {
//                   label: "Promo Discount",
//                   value: `−AED ${Math.abs(order.promo).toFixed(2)}`,
//                   color: "#92400e",
//                   bg: "#fffbeb",
//                 },
//                 {
//                   label: "Charged to Customer",
//                   value: isExpired ? "—" : `AED ${order.charged?.toFixed(2)}`,
//                   color: "#111",
//                   bg: "#f9f9f9",
//                   bold: true,
//                 },
//                 {
//                   label: "Washta Platform Fee",
//                   value: isExpired ? "—" : `AED ${order.platformFee?.toFixed(2)}`,
//                   color: "#4a3db8",
//                   bg: "#f7f5ff",
//                 },
//                 {
//                   label: "Stripe Processing Fee",
//                   value: isExpired ? "—" : `−AED ${Math.abs(order.stripeFee).toFixed(2)}`,
//                   color: "#991b1b",
//                   bg: "#fff",
//                 },
//                 {
//                   label: "Washta Commission",
//                   value: isExpired ? "—" : `+AED ${order.commission?.toFixed(2)}`,
//                   color: "#4a3db8",
//                   bg: "#f7f5ff",
//                 },
//                 {
//                   label: "Washta Net Revenue",
//                   value: isExpired ? "—" : `AED ${order.net?.toFixed(2)}`,
//                   color: "#065f46",
//                   bg: "#f0fdf4",
//                   bold: true,
//                 },
//                 {
//                   label: "Provider Entitlement",
//                   value:
//                     order.providerEntitlement != null
//                       ? `AED ${order.providerEntitlement.toFixed(2)}`
//                       : "—",
//                   color: "#111",
//                   bg: "#fff",
//                 },
//               ]
//                 .filter(Boolean)
//                 .map((row, index, arr) => (
//                   <div
//                     key={index}
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       padding: "9px 13px",
//                       background: row.bg,
//                       borderBottom: index < arr.length - 1 ? "1px solid #f0f0f0" : "none",
//                     }}
//                   >
//                     <span style={{ fontSize: 11, color: "#555" }}>{row.label}</span>
//                     <span
//                       style={{
//                         fontSize: 12,
//                         fontFamily: "monospace",
//                         fontWeight: row.bold ? 800 : 600,
//                         color: row.color,
//                       }}
//                     >
//                       {row.value}
//                     </span>
//                   </div>
//                 ))}
//             </div>
//           </div>

//           {order.status === "Completed" && (
//             <div
//               style={{
//                 background: "#f0fdf4",
//                 border: "1px solid #bbf7d0",
//                 borderRadius: 8,
//                 padding: "8px 12px",
//                 fontSize: 10,
//                 color: "#1a6641",
//                 lineHeight: 1.6,
//               }}
//             >
//               ✅ QB Auto-sync: Entry No.1 fired on completion · one-way to QB only.
//             </div>
//           )}

//           {order.status === "Expired" && (
//             <div
//               style={{
//                 background: "#eef2ff",
//                 border: "1px solid #c7d2fe",
//                 borderRadius: 8,
//                 padding: "8px 12px",
//                 fontSize: 10,
//                 color: "#4338ca",
//                 lineHeight: 1.6,
//               }}
//             >
//               ⏱ This order expired by the system after 12 hours without seller acceptance.
//             </div>
//           )}

//           {order.status === "Cancelled" && (
//             <div
//               style={{
//                 background: "#fff1f2",
//                 border: "1px solid #fecdd3",
//                 borderRadius: 8,
//                 padding: "8px 12px",
//                 fontSize: 10,
//                 color: "#991b1b",
//                 lineHeight: 1.6,
//               }}
//             >
//               Seller cancelled this order. Refund is pending until admin marks isRefunded=true.
//             </div>
//           )}

//           {order.status === "Refunded" && (
//             <div
//               style={{
//                 background: "#f0fdf4",
//                 border: "1px solid #bbf7d0",
//                 borderRadius: 8,
//                 padding: "8px 12px",
//                 fontSize: 10,
//                 color: "#166534",
//                 lineHeight: 1.6,
//               }}
//             >
//               🔄 Order refunded. QB reversal journal may be required — flag to accountant.
//             </div>
//           )}
//         </div>

//         <div
//           style={{
//             padding: "12px 22px 16px",
//             borderTop: "1px solid #f0f0f0",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: 8,
//           }}
//         >
//           <span style={{ fontSize: 10, color: "#aaa" }}>Generated by Washta Platform</span>
//           <button
//             onClick={onClose}
//             style={{
//               fontSize: 11,
//               fontWeight: 600,
//               padding: "7px 18px",
//               background: "#6B5FE4",
//               color: "#fff",
//               border: "none",
//               borderRadius: 8,
//               cursor: "pointer",
//             }}
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function exportToXLSX(data) {
//   const rows = data.map((o) => ({
//     "Order ID": o.readableOrderId || getOrderNumber(o.rawId),
//     Date: o.date,
//     Time: o.time,
//     Provider: o.provider,
//     Location: o.location,
//     Customer: o.customer,
//     Email: o.email,
//     Vehicle: o.vehicle,
//     Plate: o.plate,
//     "Car Type": o.carType,
//     Service: o.service,
//     "Add-ons": o.addons,
//     "Promo Code": o.promoCode || "",
//     "Shop Price (AED)": o.shopPrice,
//     "Promo Discount (AED)": o.promo != null ? Math.abs(o.promo) : "",
//     "Charged to Customer (AED)": o.charged != null ? o.charged : "",
//     "Washta Platform Fee (AED)": o.platformFee != null ? o.platformFee : "",
//     "Stripe Fee (AED)": o.stripeFee != null ? Math.abs(o.stripeFee) : "",
//     "Commission (AED)": o.commission != null ? o.commission : "",
//     "Washta Net (AED)": o.net != null ? o.net : "",
//     "Provider Entitlement (AED)": o.providerEntitlement != null ? o.providerEntitlement : "",
//     Status: o.status,
//     "Status Reason": o.statusReason || "",
//     "Is Refunded": o.isRefunded ? "TRUE" : "FALSE",
//     "Stripe Payment ID": o.stripeId || "",
//   }));

//   const ws = XLSX.utils.json_to_sheet(rows);
//   ws["!cols"] = [
//     { wch: 20 },
//     { wch: 10 },
//     { wch: 10 },
//     { wch: 15 },
//     { wch: 22 },
//     { wch: 14 },
//     { wch: 22 },
//     { wch: 18 },
//     { wch: 10 },
//     { wch: 10 },
//     { wch: 14 },
//     { wch: 18 },
//     { wch: 12 },
//     { wch: 18 },
//     { wch: 20 },
//     { wch: 24 },
//     { wch: 22 },
//     { wch: 18 },
//     { wch: 18 },
//     { wch: 18 },
//     { wch: 24 },
//     { wch: 12 },
//     { wch: 42 },
//     { wch: 14 },
//     { wch: 32 },
//   ];

//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "All Orders");

//   const completed = data.filter((o) => o.status === "Completed");
//   const totalCharged = completed.reduce((sum, o) => sum + (o.charged || 0), 0);
//   const totalNet = completed.reduce((sum, o) => sum + (o.net || 0), 0);
//   const totalCommission = completed.reduce((sum, o) => sum + (o.commission || 0), 0);
//   const totalPlatformFee = completed.reduce((sum, o) => sum + (o.platformFee || 0), 0);
//   const totalProviderPayout = completed.reduce((sum, o) => sum + (o.providerEntitlement || 0), 0);

//   const summaryRows = [
//     { Metric: "Total Orders", Value: data.length },
//     { Metric: "Completed", Value: data.filter((o) => o.status === "Completed").length },
//     { Metric: "Cancelled by Seller", Value: data.filter((o) => o.status === "Cancelled").length },
//     { Metric: "Refunded", Value: data.filter((o) => o.status === "Refunded").length },
//     { Metric: "Expired by System", Value: data.filter((o) => o.status === "Expired").length },
//     { Metric: "" },
//     { Metric: "Total Charged to Customers (AED)", Value: +totalCharged.toFixed(2) },
//     { Metric: "Total Washta Commission (AED)", Value: +totalCommission.toFixed(2) },
//     { Metric: "Total Washta Platform Fee (AED)", Value: +totalPlatformFee.toFixed(2) },
//     {
//       Metric: "Total Stripe Fees (AED)",
//       Value: +data.reduce((sum, o) => sum + Math.abs(o.stripeFee || 0), 0).toFixed(2),
//     },
//     { Metric: "Total Washta Net (AED)", Value: +totalNet.toFixed(2) },
//     { Metric: "Total Provider Payouts (AED)", Value: +totalProviderPayout.toFixed(2) },
//   ];

//   const ws2 = XLSX.utils.json_to_sheet(summaryRows);
//   ws2["!cols"] = [{ wch: 38 }, { wch: 18 }];
//   XLSX.utils.book_append_sheet(wb, ws2, "Summary");

//   XLSX.writeFile(wb, `Washta_Orders_${new Date().toISOString().slice(0, 10)}.xlsx`);
// }

// export default function AllOrders() {
//   const [orders, setOrders] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   const [statusFilter, setStatusFilter] = useState("All Statuses");
//   const [providerFilter, setProviderFilter] = useState("All Providers");
//   const [serviceFilter, setServiceFilter] = useState("All Services");
//   const [search, setSearch] = useState("");

//   const [refundConfirm, setRefundConfirm] = useState(false);
//   const [refundReason, setRefundReason] = useState("");
//   const [refundLoading, setRefundLoading] = useState(false);
//   const [refundError, setRefundError] = useState("");

//   const [mobileDrawer, setMobileDrawer] = useState(false);
//   const [receiptOrder, setReceiptOrder] = useState(null);

//   const [timeFilter, setTimeFilter] = useState("Today");
//   const [customDate, setCustomDate] = useState("");

//   const fetchOrders = async () => {
//     try {
//       const token = localStorage.getItem("accessTokenAdmin");
//       if (!token) return;

//       const response = await axios.get(`${ADMIN_BASE}/orders?limit=500`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       const rows = (response.data?.data || response.data || []).map(transformOrder);

//       setOrders(rows);
//       setSelectedOrder((current) => {
//         if (!current) return rows[0] || null;
//         return rows.find((row) => row.rawId === current.rawId || row.id === current.id) || rows[0] || null;
//       });
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const handleRefundOrder = async () => {
//     if (!selectedOrder || !refundReason.trim()) return;

//     try {
//       setRefundLoading(true);
//       setRefundError("");

//       const token = localStorage.getItem("accessTokenAdmin");
//       if (!token) throw new Error("Admin token not found. Please login again.");

//       const payload = {
//         isRefunded: true,
//         refundReason: refundReason.trim(),
//         orderId: selectedOrder.rawId,
//         // paymentId: selectedOrder.stripeId,
//       };

//       const response = await axios.patch(
//         `${ADMIN_BASE}/orders/${selectedOrder.rawId}/refund`,
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const updatedRawOrder = response.data?.data || response.data?.order || response.data;

//       const updatedOrder = updatedRawOrder?._id
//         ? transformOrder(updatedRawOrder)
//         : {
//             ...selectedOrder,
//             status: "Refunded",
//             statusReason: "Admin refunded this order.",
//             isRefunded: true,
//             refundReason: refundReason.trim(),
//             refundedAt: new Date().toISOString(),
//           };

//       setOrders((prev) =>
//         prev.map((order) =>
//           order.rawId === selectedOrder.rawId || order.id === selectedOrder.id
//             ? updatedOrder
//             : order
//         )
//       );

//       setSelectedOrder(updatedOrder);
//       setRefundConfirm(false);
//       setRefundReason("");

//       await fetchOrders();
//     } catch (error) {
//       console.error("Refund update failed:", error);
//       setRefundError(error.response?.data?.message || error.message || "Refund update failed.");
//     } finally {
//       setRefundLoading(false);
//     }
//   };

//   const filtered = useMemo(() => {
//     const now = moment();
//     let rangeStart = moment(now).startOf("day");
//     let rangeEnd = moment(now).endOf("day");
//     let noDateFilter = false;

//     if (customDate) {
//       rangeStart = moment(customDate, "YYYY-MM-DD").startOf("day");
//       rangeEnd = moment(customDate, "YYYY-MM-DD").endOf("day");
//     } else if (timeFilter === "This Week") {
//       rangeStart = moment(now).subtract(6, "days").startOf("day");
//     } else if (timeFilter === "This Month") {
//       rangeStart = moment(now).subtract(29, "days").startOf("day");
//     } else if (timeFilter === "All Time") {
//       noDateFilter = true;
//     }

//     return orders.filter((order) => {
//       if (!noDateFilter && order.createdAt) {
//         const orderDate = moment.utc(order.createdAt).local();
//         if (orderDate.isBefore(rangeStart)) return false;
//         if (customDate && orderDate.isAfter(rangeEnd)) return false;
//       }

//       if (statusFilter !== "All Statuses" && order.status !== statusFilter) return false;
//       if (providerFilter !== "All Providers" && order.provider !== providerFilter) return false;
//       if (serviceFilter !== "All Services" && order.service !== serviceFilter) return false;

//       if (search) {
//         const query = search.trim().toLowerCase();
//         const readableId = order.readableOrderId || getOrderNumber(order.rawId);

//         const searchable = [
//           readableId,
//           order.rawId,
//           order.id,
//           order.plate,
//           order.customer,
//           order.email,
//           order.stripeId || "",
//         ]
//           .filter(Boolean)
//           .join(" ")
//           .toLowerCase();

//         if (!searchable.includes(query)) return false;
//       }

//       return true;
//     });
//   }, [orders, timeFilter, customDate, statusFilter, providerFilter, serviceFilter, search]);

//   const providerOptions = useMemo(
//     () => ["All Providers", ...Array.from(new Set(orders.map((order) => order.provider).filter(Boolean)))],
//     [orders]
//   );

//   const serviceOptions = useMemo(
//     () => ["All Services", ...Array.from(new Set(orders.map((order) => order.service).filter(Boolean)))],
//     [orders]
//   );

//   function openDrawer(order) {
//     setSelectedOrder(order);
//     setDrawerOpen(true);
//     setRefundConfirm(false);
//     setRefundReason("");
//     setRefundError("");
//     setMobileDrawer(true);
//   }

//   return (
//     <div
//       className="mainDiv-all-sideBar"
//       style={{ display: "flex", minHeight: "100vh", background: "#f0f0f5" }}
//     >
//       <div className="div-sidebar">
//         <AdminSidebar />
//       </div>

//       <div
//         className="div-Dashbaord"
//         style={{
//           flex: 1,
//           minWidth: 0,
//           display: "flex",
//           flexDirection: "column",
//           overflow: "hidden",
//           padding: 0,
//           background: "white",
//         }}
//       >
//         <div style={{ flex: 1, display: "flex", minHeight: 0, overflow: "hidden" }}>
//           <div
//             style={{
//               flex: 1,
//               minWidth: 0,
//               overflowY: "auto",
//               padding: "20px 20px 40px",
//             }}
//           >
//             <h1 className="ws-view-title">All Orders</h1>

//             <p style={{ fontSize: 11, color: "#888", marginBottom: 14, lineHeight: 1.5 }}>
//               Every transaction across all providers. Cancelled means seller cancelled. Expired
//               means system expired after 12 hours. Refunded means admin has marked isRefunded=true.
//             </p>

//             <div
//               style={{
//                 display: "flex",
//                 gap: 7,
//                 alignItems: "center",
//                 marginBottom: 14,
//                 flexWrap: "wrap",
//               }}
//             >
//               {["Today", "This Week", "This Month", "All Time"].map((d) => (
//                 <button
//                   key={d}
//                   onClick={() => {
//                     setTimeFilter(d);
//                     setCustomDate("");
//                   }}
//                   style={{
//                     fontSize: 10,
//                     padding: "4px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: 20,
//                     color: !customDate && timeFilter === d ? "#fff" : "#888",
//                     cursor: "pointer",
//                     background: !customDate && timeFilter === d ? "#6B5FE4" : "#fff",
//                     borderColor: !customDate && timeFilter === d ? "#6B5FE4" : "#ddd",
//                   }}
//                 >
//                   {d}
//                 </button>
//               ))}

//               <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
//                 <input
//                   type="date"
//                   value={customDate}
//                   onChange={(e) => setCustomDate(e.target.value)}
//                   max={moment().format("YYYY-MM-DD")}
//                   style={{
//                     fontSize: 10,
//                     padding: "4px 10px",
//                     paddingRight: customDate ? 26 : 10,
//                     border: "1px solid #ddd",
//                     borderRadius: 20,
//                     color: customDate ? "#fff" : "#888",
//                     cursor: "pointer",
//                     background: customDate ? "#6B5FE4" : "#fff",
//                     borderColor: customDate ? "#6B5FE4" : "#ddd",
//                     fontFamily: "inherit",
//                     colorScheme: customDate ? "dark" : "light",
//                     outline: "none",
//                   }}
//                 />

//                 {customDate && (
//                   <button
//                     onClick={() => setCustomDate("")}
//                     title="Clear date filter"
//                     style={{
//                       position: "absolute",
//                       right: 6,
//                       background: "none",
//                       border: "none",
//                       color: "#fff",
//                       fontSize: 11,
//                       lineHeight: 1,
//                       cursor: "pointer",
//                       padding: 0,
//                     }}
//                   >
//                     ✕
//                   </button>
//                 )}
//               </div>

//               {[
//                 {
//                   value: providerFilter,
//                   onChange: setProviderFilter,
//                   options: providerOptions,
//                 },
//                 {
//                   value: statusFilter,
//                   onChange: setStatusFilter,
//                   options: ["All Statuses", "Completed", "Cancelled", "Refunded", "Expired", "Pending"],
//                 },
//                 {
//                   value: serviceFilter,
//                   onChange: setServiceFilter,
//                   options: serviceOptions,
//                 },
//               ].map(({ value, onChange, options }, index) => (
//                 <select
//                   key={index}
//                   value={value}
//                   onChange={(e) => onChange(e.target.value)}
//                   style={{
//                     fontSize: 11,
//                     color: "#111",
//                     border: "1px solid #ddd",
//                     borderRadius: 7,
//                     padding: "5px 8px",
//                     background: "#fff",
//                     fontFamily: "inherit",
//                   }}
//                 >
//                   {options.map((option) => (
//                     <option key={option}>{option}</option>
//                   ))}
//                 </select>
//               ))}

//               <input
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Order ID, raw ID, plate, customer, Stripe ID…"
//                 style={{
//                   fontSize: 11,
//                   border: "1px solid #ddd",
//                   borderRadius: 7,
//                   padding: "5px 9px",
//                   background: "#fff",
//                   color: "#111",
//                   fontFamily: "inherit",
//                   width: 240,
//                   marginLeft: "auto",
//                 }}
//               />

//               <button
//                 onClick={() => exportToXLSX(filtered)}
//                 style={{
//                   fontSize: 10,
//                   fontWeight: 600,
//                   padding: "5px 11px",
//                   borderRadius: 7,
//                   cursor: "pointer",
//                   background: "#fff",
//                   color: "#111",
//                   border: "1px solid #ddd",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 4,
//                 }}
//               >
//                 ↓ Export
//               </button>
//             </div>

//             <div style={{ overflowX: "auto" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
//                 <thead>
//                   <tr>
//                     {[
//                       "Order ID",
//                       "Date / Time",
//                       "Provider · Location",
//                       "Customer",
//                       "Vehicle",
//                       "Service",
//                       "Shop Price",
//                       "Promo",
//                       "Charged",
//                       "Stripe Fee",
//                       "Commission",
//                       "Net",
//                       "Status",
//                     ].map((header, index) => (
//                       <th
//                         key={header}
//                         style={{
//                           fontSize: 9,
//                           fontWeight: 700,
//                           color: "#aaa",
//                           textTransform: "uppercase",
//                           letterSpacing: "0.06em",
//                           padding: "7px 10px",
//                           textAlign: index >= 6 && index <= 11 ? "right" : "left",
//                           borderBottom: "1.5px solid #eee",
//                           background: "#f7f7f9",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {header}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {filtered.map((order) => {
//                     const isExpired = order.status === "Expired";
//                     const isRefunded = order.status === "Refunded";
//                     const isCancelled = order.status === "Cancelled";
//                     const isSelected = selectedOrder?.id === order.id && drawerOpen;

//                     return (
//                       <tr
//                         key={order.id}
//                         onClick={() => openDrawer(order)}
//                         style={{
//                           cursor: "pointer",
//                           background: isRefunded
//                             ? "#fff1f2"
//                             : isCancelled
//                             ? "#fff1f2"
//                             : isSelected
//                             ? "#f0eeff"
//                             : "transparent",
//                           transition: "background 0.1s",
//                         }}
//                         onMouseEnter={(e) => {
//                           if (!isSelected) e.currentTarget.style.background = "#fafafa";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.background = isRefunded
//                             ? "#fff1f2"
//                             : isCancelled
//                             ? "#fff1f2"
//                             : isSelected
//                             ? "#f0eeff"
//                             : "transparent";
//                         }}
//                       >
//                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
//                           <div
//                             style={{
//                               fontSize: 10,
//                               color: "#6B5FE4",
//                               fontFamily: "monospace",
//                               fontWeight: 600,
//                             }}
//                           >
//                             {order.readableOrderId || getOrderNumber(order.rawId)}
//                           </div>
//                         </td>

//                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
//                           <div style={{ fontSize: 11 }}>{order.date}</div>
//                           <div style={{ fontSize: 10, color: "#aaa" }}>{order.time}</div>
//                         </td>

//                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
//                           <div style={{ fontWeight: 700, fontSize: 11 }}>{order.provider}</div>
//                           <div style={{ fontSize: 10, color: "#888" }}>{order.location}</div>
//                         </td>

//                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
//                           <div style={{ fontSize: 11 }}>{order.customer}</div>
//                           <div style={{ fontSize: 10, color: "#aaa" }}>{order.email}</div>
//                         </td>

//                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
//                           <div style={{ fontSize: 11 }}>{order.vehicle}</div>
//                           <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
//                             <Plate text={order.plate} />
//                             <span style={{ fontSize: 9, color: "#888" }}>{order.carType}</span>
//                           </div>
//                         </td>

//                         <td
//                           style={{
//                             padding: "8px 10px",
//                             borderBottom: "1px solid #f5f5f5",
//                             fontSize: 11,
//                             color: isExpired ? "#aaa" : "#4a3db8",
//                             fontWeight: 600,
//                           }}
//                         >
//                           {order.service}
//                         </td>

//                         <td
//                           style={{
//                             padding: "8px 10px",
//                             borderBottom: "1px solid #f5f5f5",
//                             textAlign: "right",
//                             fontSize: 11,
//                             fontFamily: "monospace",
//                           }}
//                         >
//                           AED {order.shopPrice.toFixed(2)}
//                         </td>

//                         <td
//                           style={{
//                             padding: "8px 10px",
//                             borderBottom: "1px solid #f5f5f5",
//                             textAlign: "right",
//                             fontSize: 11,
//                             fontFamily: "monospace",
//                             color: "#92400e",
//                           }}
//                         >
//                           {order.promo ? `−${Math.abs(order.promo).toFixed(2)}` : <Dash />}
//                         </td>

//                         <td
//                           style={{
//                             padding: "8px 10px",
//                             borderBottom: "1px solid #f5f5f5",
//                             textAlign: "right",
//                             fontSize: 11,
//                             fontFamily: "monospace",
//                           }}
//                         >
//                           {isExpired ? <Dash /> : order.charged?.toFixed(2)}
//                         </td>

//                         <td
//                           style={{
//                             padding: "8px 10px",
//                             borderBottom: "1px solid #f5f5f5",
//                             textAlign: "right",
//                             fontSize: 11,
//                             fontFamily: "monospace",
//                             color: "#991b1b",
//                           }}
//                         >
//                           {isExpired ? <Dash /> : `−${Math.abs(order.stripeFee).toFixed(2)}`}
//                         </td>

//                         <td
//                           style={{
//                             padding: "8px 10px",
//                             borderBottom: "1px solid #f5f5f5",
//                             textAlign: "right",
//                             fontSize: 11,
//                             fontFamily: "monospace",
//                             color: "#4a3db8",
//                           }}
//                         >
//                           {isExpired ? (
//                             <Dash />
//                           ) : order.commission != null ? (
//                             `+${order.commission.toFixed(2)}`
//                           ) : (
//                             <Dash />
//                           )}
//                         </td>

//                         <td
//                           style={{
//                             padding: "8px 10px",
//                             borderBottom: "1px solid #f5f5f5",
//                             textAlign: "right",
//                             fontSize: 11,
//                             fontFamily: "monospace",
//                             fontWeight: 700,
//                           }}
//                         >
//                           {isExpired ? <Dash /> : order.net != null ? order.net.toFixed(2) : <Dash />}
//                         </td>

//                         <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
//                           <StatusPill status={order.status} />
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             <div
//               style={{
//                 fontSize: 11,
//                 color: "#888",
//                 marginTop: 10,
//                 paddingTop: 10,
//                 borderTop: "1px solid #f0f0f0",
//               }}
//             >
//               Showing {filtered.length} of {orders.length}
//               {customDate && (
//                 <>
//                   {" "}
//                   · Date: <strong>{moment(customDate, "YYYY-MM-DD").format("DD/MM/YYYY")}</strong>
//                 </>
//               )}
//             </div>
//           </div>

//           {drawerOpen && selectedOrder && (
//             <div
//               style={{
//                 width: 320,
//                 flexShrink: 0,
//                 borderLeft: "1px solid #eee",
//                 overflowY: "auto",
//                 background: "#fff",
//               }}
//             >
//               <div
//                 style={{
//                   background: "#f7f7f9",
//                   borderBottom: "1px solid #eee",
//                   padding: "10px 14px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 1,
//                 }}
//               >
//                 <div>
//                   <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>Order Detail</div>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#6B5FE4",
//                       fontFamily: "monospace",
//                       marginTop: 2,
//                     }}
//                   >
//                     {selectedOrder.readableOrderId || getOrderNumber(selectedOrder.rawId)}
//                   </div>
//                 </div>

//                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                   <StatusPill status={selectedOrder.status} />
//                   <button
//                     onClick={() => {
//                       setDrawerOpen(false);
//                       setMobileDrawer(false);
//                     }}
//                     style={{
//                       fontSize: 16,
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                       color: "#888",
//                       lineHeight: 1,
//                       padding: "0 4px",
//                     }}
//                   >
//                     ✕
//                   </button>
//                 </div>
//               </div>

//               <div
//                 style={{
//                   padding: 14,
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 14,
//                 }}
//               >
//                 <DrawerField
//                   label="Washta Order ID"
//                   value={
//                     <span style={{ fontFamily: "monospace", fontSize: 11, color: "#6B5FE4" }}>
//                       {selectedOrder.readableOrderId || getOrderNumber(selectedOrder.rawId)}
//                     </span>
//                   }
//                 />

//                 <DrawerField
//                   label="Date / Time"
//                   value={`${selectedOrder.date} · ${selectedOrder.time}`}
//                 />

//                 <div style={{ gridColumn: "1 / -1" }}>
//                   <DrawerField
//                     label="Stripe Payment ID"
//                     value={
//                       selectedOrder.stripeId ? (
//                         <span style={{ fontFamily: "monospace", fontSize: 10, color: "#111" }}>
//                           {selectedOrder.stripeId}
//                         </span>
//                       ) : (
//                         <span style={{ color: "#aaa", fontSize: 11 }}>— not charged</span>
//                       )
//                     }
//                   />
//                 </div>

//                 <DrawerField
//                   label="Provider · Location"
//                   value={`${selectedOrder.provider} · ${selectedOrder.location}`}
//                 />

//                 <DrawerField
//                   label="Customer"
//                   value={`${selectedOrder.customer} · ${selectedOrder.email}`}
//                 />

//                 <DrawerField
//                   label="Vehicle"
//                   value={
//                     <span>
//                       {selectedOrder.vehicle} · <Plate text={selectedOrder.plate} /> ·{" "}
//                       {selectedOrder.carType}
//                     </span>
//                   }
//                 />

//                 <DrawerField
//                   label="Service"
//                   value={<span style={{ color: "#4a3db8" }}>{selectedOrder.service}</span>}
//                 />

//                 <DrawerField
//                   label="Add-ons"
//                   value={<span style={{ color: "#1a6641" }}>{selectedOrder.addons}</span>}
//                 />

//                 <DrawerField
//                   label="Promo Code"
//                   value={
//                     selectedOrder.promoCode
//                       ? `${selectedOrder.promoCode}${
//                           selectedOrder.promoDiscountRaw != null
//                             ? ` · ${
//                                 selectedOrder.promoDiscountType === "percentage"
//                                   ? `${selectedOrder.promoDiscountRaw}% off`
//                                   : `AED ${selectedOrder.promoDiscountRaw.toFixed(2)} off`
//                               }`
//                             : ""
//                         } · −AED ${Math.abs(selectedOrder.promo).toFixed(2)} · Washta absorbed`
//                       : "None"
//                   }
//                 />

//                 <DrawerField
//                   label="Base Service Price"
//                   value={`AED ${selectedOrder.baseShopPrice.toFixed(2)}`}
//                 />

//                 <DrawerField
//                   label="Add-ons Total"
//                   value={
//                     selectedOrder.addonsTotal > 0 ? (
//                       <span style={{ color: "#1a6641" }}>
//                         +AED {selectedOrder.addonsTotal.toFixed(2)}
//                       </span>
//                     ) : (
//                       "—"
//                     )
//                   }
//                 />

//                 <DrawerField
//                   label="Shop Price"
//                   value={`AED ${selectedOrder.shopPrice.toFixed(2)}`}
//                 />

//                 <DrawerField
//                   label="Charged to Customer"
//                   value={
//                     selectedOrder.charged != null ? `AED ${selectedOrder.charged.toFixed(2)}` : "—"
//                   }
//                 />

//                 <DrawerField
//                   label="Platform Fee"
//                   value={
//                     selectedOrder.platformFee != null ? (
//                       <span style={{ color: "#4a3db8" }}>
//                         AED {selectedOrder.platformFee.toFixed(2)}
//                       </span>
//                     ) : (
//                       "—"
//                     )
//                   }
//                 />

//                 <DrawerField
//                   label="Stripe Fee"
//                   value={
//                     selectedOrder.stripeFee != null ? (
//                       <span style={{ color: "#991b1b" }}>
//                         − AED {Math.abs(selectedOrder.stripeFee).toFixed(2)}
//                       </span>
//                     ) : (
//                       "—"
//                     )
//                   }
//                 />

//                 <DrawerField
//                   label="Commission"
//                   value={
//                     selectedOrder.commission != null ? (
//                       <span style={{ color: "#4a3db8" }}>
//                         + AED {selectedOrder.commission.toFixed(2)}
//                       </span>
//                     ) : (
//                       "—"
//                     )
//                   }
//                 />

//                 <DrawerField
//                   label="Washta Net"
//                   value={
//                     selectedOrder.net != null ? (
//                       <span style={{ color: "#1a6641" }}>AED {selectedOrder.net.toFixed(2)}</span>
//                     ) : (
//                       "—"
//                     )
//                   }
//                 />

//                 <DrawerField
//                   label="Provider Entitlement"
//                   value={
//                     selectedOrder.providerEntitlement != null
//                       ? `AED ${selectedOrder.providerEntitlement.toFixed(2)}`
//                       : "—"
//                   }
//                 />

//                 <div style={{ gridColumn: "1 / -1" }}>
//                   <DrawerField
//                     label="QB Auto-sync"
//                     value={
//                       selectedOrder.status === "Completed" ? (
//                         <span style={{ fontSize: 11, color: "#1a6641" }}>
//                           Entry No.1 fired on completion · one-way to QB only.
//                         </span>
//                       ) : (
//                         <span style={{ fontSize: 11, color: "#aaa" }}>— not applicable</span>
//                       )
//                     }
//                   />
//                 </div>
//               </div>

//               {selectedOrder.statusReason && (
//                 <div
//                   style={{
//                     margin: "0 14px 14px",
//                     background:
//                       selectedOrder.status === "Cancelled"
//                         ? "#fff1f2"
//                         : selectedOrder.status === "Refunded"
//                         ? "#fff1f2"
//                         : "#eef2ff",
//                     border: "1px solid #e5e7eb",
//                     borderRadius: 8,
//                     padding: "8px 12px",
//                     fontSize: 10,
//                     color:
//                       selectedOrder.status === "Cancelled"
//                         ? "#991b1b"
//                         : selectedOrder.status === "Refunded"
//                         ? "#991b1b"
//                         : "#4338ca",
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   {selectedOrder.statusReason}
//                   {selectedOrder.refundReason ? ` Reason: ${selectedOrder.refundReason}` : ""}
//                 </div>
//               )}

//               <div
//                 style={{
//                   padding: "12px 14px",
//                   background: "#fafafa",
//                   borderTop: "1px solid #eee",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   gap: 8,
//                 }}
//               >
//                 <button
//                   onClick={() => setReceiptOrder(selectedOrder)}
//                   style={{
//                     fontSize: 10,
//                     fontWeight: 600,
//                     padding: "6px 14px",
//                     background: "#fff",
//                     color: "#6B5FE4",
//                     border: "1px solid #d8d2ff",
//                     borderRadius: 7,
//                     cursor: "pointer",
//                   }}
//                 >
//                   View Receipt
//                 </button>

//                 {canRefundOrder(selectedOrder) && (
//                   <button
//                     onClick={() => {
//                       setRefundConfirm(true);
//                       setRefundError("");
//                     }}
//                     style={{
//                       fontSize: 10,
//                       fontWeight: 700,
//                       padding: "6px 14px",
//                       background: "#fee2e2",
//                       color: "#991b1b",
//                       border: "1px solid #fca5a5",
//                       borderRadius: 7,
//                       cursor: "pointer",
//                     }}
//                   >
//                     Issue Refund
//                   </button>
//                 )}
//               </div>

//               {refundConfirm && (
//                 <div style={{ padding: "10px 14px 14px" }}>
//                   <div
//                     style={{
//                       background: "#fff3cd",
//                       border: "1px solid #fbbf24",
//                       borderRadius: 8,
//                       padding: "10px 12px",
//                       marginBottom: 10,
//                       fontSize: 10,
//                       color: "#92400e",
//                       lineHeight: 1.6,
//                     }}
//                   >
//                     ⚠️ This will mark the order as refunded and set isRefunded=true.
//                   </div>

//                   <textarea
//                     value={refundReason}
//                     onChange={(e) => setRefundReason(e.target.value)}
//                     placeholder="Reason for refund (required)…"
//                     rows={3}
//                     style={{
//                       width: "100%",
//                       fontSize: 11,
//                       border: "1px solid #ddd",
//                       borderRadius: 7,
//                       padding: "7px 9px",
//                       fontFamily: "inherit",
//                       resize: "vertical",
//                       marginBottom: 8,
//                       boxSizing: "border-box",
//                     }}
//                   />

//                   {refundError && (
//                     <div style={{ fontSize: 10, color: "#991b1b", marginBottom: 8 }}>
//                       {refundError}
//                     </div>
//                   )}

//                   <div style={{ display: "flex", gap: 8 }}>
//                     <button
//                       onClick={() => setRefundConfirm(false)}
//                       style={{
//                         flex: 1,
//                         fontSize: 10,
//                         fontWeight: 600,
//                         padding: "6px 0",
//                         background: "#fff",
//                         color: "#666",
//                         border: "1px solid #ddd",
//                         borderRadius: 7,
//                         cursor: "pointer",
//                       }}
//                     >
//                       Cancel
//                     </button>

//                     <button
//                       disabled={!refundReason.trim() || refundLoading}
//                       onClick={handleRefundOrder}
//                       style={{
//                         flex: 2,
//                         fontSize: 10,
//                         fontWeight: 700,
//                         padding: "6px 0",
//                         background: refundReason.trim() && !refundLoading ? "#fee2e2" : "#f3f4f6",
//                         color: refundReason.trim() && !refundLoading ? "#991b1b" : "#aaa",
//                         border: `1px solid ${
//                           refundReason.trim() && !refundLoading ? "#fca5a5" : "#eee"
//                         }`,
//                         borderRadius: 7,
//                         cursor: refundReason.trim() && !refundLoading ? "pointer" : "not-allowed",
//                       }}
//                     >
//                       {refundLoading ? "Saving..." : "Confirm Refund"}
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {["Expired", "Refunded", "Cancelled"].includes(selectedOrder.status) && (
//                 <div
//                   style={{
//                     margin: "0 14px 14px",
//                     background: "#f0eeff",
//                     border: "1px solid #d8d2ff",
//                     borderRadius: 8,
//                     padding: "8px 12px",
//                     fontSize: 10,
//                     color: "#4a3db8",
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   {selectedOrder.status === "Expired"
//                     ? "This order expired by the system after 12 hours without seller acceptance."
//                     : selectedOrder.status === "Refunded"
//                     ? "This order is already refunded. QB reversal journal may be required."
//                     : "This order was cancelled by the seller. Use Issue Refund when admin refund is ready."}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {receiptOrder && <ReceiptModal order={receiptOrder} onClose={() => setReceiptOrder(null)} />}

//       <style>{`
//         @media (max-width: 768px) {
//           .mainDiv-all-sideBar {
//             flex-direction: column;
//           }

//           .div-sidebar {
//             width: 100% !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }
import AdminSidebar from "admin/sidebar/AdminSidebar";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { getReadableOrderId } from "pages/utils/HelperFun";
import moment from "moment";
import { formatDate, formatTimeInTimezone } from "pages/utils/formdatedynamics";

const API_BASE = process.env.REACT_APP_API_URL || 'https://backend.washta.com';
const DASHBOARD_V2_URL = `${API_BASE}/api/admin/v2/dashboard`;

const safeNumber = (value) => {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getOrderNumber = (data, prefix = 'WS') => {
  console.log('data',data)
  const id = typeof data === 'string'
    ? data
    : data?._id || data?.id;

  if (!id) return `${prefix}-—`;

  return getReadableOrderId(String(id), prefix);
};
const formatLocation = (order) => order.location || order.serviceLocation?.text || order.shopLocationText || '—';

const formatCustomerName = (order) => order.customer || order.customerId?.username || order.customerId?.fullName || order.customerId?.email || '—';

const formatShopName = (order) => order.provider || order.shopName || order.shopId?.shopName || '—';

const formatStatus = (order) => {
  if (order.isExpired) return 'Expired';
  if (order.billingStatus === 'paid' && (order.status === 'cancelled' || order.cancelBy)) return 'Refunded';
  if (order.status === 'completed') return 'Completed';
  if (order.status === 'inprocess' || order.status === 'ongoing') return 'Pending';
  return 'Pending';
};

const formatAddons = (order) => {
  const addons = order.selectedAddOns || [];
  if (!addons.length) return '—';
  return addons.map((addon) => addon.name).filter(Boolean).join(', ') || '—';
};

const getAddonsTotal = (order) => {
  const fromField = safeNumber(order.addOnsTotal);
  if (fromField) return fromField;
  const addons = order.selectedAddOns || [];
  return addons.reduce((sum, addon) => sum + safeNumber(addon.price), 0);
};

// Resolve the actual AED discount amount for a promo code.
// Backend sometimes sends a precomputed top-level `discount` (AED amount) — trust that when present.
// Otherwise fall back to the promoCode object, which may be a flat AED amount or a percentage.
const getPromoValue = (order, shopPrice) => {
  const topLevelDiscount = safeNumber(order.discount);
  if (topLevelDiscount > 0) return topLevelDiscount;

  const promo = order.promoCode;
  if (!promo) return 0;

  const rawDiscount = safeNumber(promo.discount);
  const isPercentage = (promo.Discounttype || promo.discountType || '').toLowerCase() === 'percentage';
  if (isPercentage) {
    return parseFloat(((shopPrice * rawDiscount) / 100).toFixed(2));
  }
  return rawDiscount;
};

const transformOrder = (order) => {
  const baseShopPrice = safeNumber(order.cost || order.finalCost || order.serviceVariant?.selectedPrice || order.serviceVariant?.basePrice);
  const addonsTotal = getAddonsTotal(order);
  const shopPrice = parseFloat((baseShopPrice + addonsTotal).toFixed(2));
  const promoValue = getPromoValue(order, shopPrice);

  const commission = shopPrice * 0.08;
  const platformFee = Math.min(5.00, Math.max(1.50, shopPrice * 0.05));
  const charged = parseFloat((shopPrice - promoValue + platformFee).toFixed(2));
  const stripeFee = parseFloat(((charged * 0.029) + 0.30).toFixed(2));
  const net = parseFloat((commission + platformFee - stripeFee - promoValue).toFixed(2));
  const providerEntitlement = Math.max(0, shopPrice - commission);
  const createdAt = order.date || order.createdAt;

  // dashboardV2 returns flat fields; old endpoint returns populated objects
  const customerObj = order.customerId && typeof order.customerId === 'object' ? order.customerId : null;
  const vehicleObj = order.vehicleId && typeof order.vehicleId === 'object' ? order.vehicleId : null;

  return {
    id: order.paymentId || order._id,
    rawId: order._id,
    date: formatDate(createdAt),
    time: formatTimeInTimezone(createdAt),
    createdAt: createdAt ? new Date(createdAt).toISOString() : null,
    provider: formatShopName(order),
    location: formatLocation(order),
    customer: formatCustomerName(order),
    email: order.customerEmail || customerObj?.email || '—',
    vehicle: order.vehicle || vehicleObj?.vehicleName || vehicleObj?.vehicleModel || vehicleObj?.vehicleManufacturer || '—',
    plate: order.vehiclePlate || vehicleObj?.vehiclePlateNumber || '—',
    carType: order.vehicleType || vehicleObj?.vehicleType || vehicleObj?.vehicleModel || '—',
    service: order.service || order.serviceName || order.serviceVariant?.variantName || '—',
    baseShopPrice,
    addonsTotal,
    shopPrice,
    promo: promoValue ? -promoValue : null,
    charged: charged || null,
    stripeFee,
    commission,
    platformFee,
    net,
    status: formatStatus(order),
    stripeId: order.paymentId || null,
    addons: formatAddons(order),
    promoCode: order.promoCode?.promoCode || null,
    promoDiscountType: (order.promoCode?.Discounttype || order.promoCode?.discountType || '').toLowerCase() || null,
    promoDiscountRaw: order.promoCode?.discount != null ? safeNumber(order.promoCode.discount) : null,
    providerEntitlement,
  };
};

const statusConfig = {
  Completed: { bg: "#d1fae5", color: "#065f46" },
  Refunded: { bg: "#f3f4f6", color: "#374151" },
  Expired: { bg: "#f3f4f6", color: "#6b7280" },
  Pending: { bg: "#fef3c7", color: "#92400e" },
};

function StatusPill({ status }) {
  const cfg = statusConfig[status] || statusConfig.Pending;
  return (
    <span
      style={{
        display: "inline-block",
        fontSize: 9,
        fontWeight: 700,
        padding: "2px 8px",
        borderRadius: 100,
        background: cfg.bg,
        color: cfg.color,
        whiteSpace: "nowrap",
      }}
    >
      {status}
    </span>
  );
}

function Plate({ text }) {
  return (
    <span
      style={{
        fontSize: 9,
        fontWeight: 700,
        background: "#fff9c4",
        color: "#5c4a00",
        border: "1px solid #ffe082",
        borderRadius: 4,
        padding: "1px 6px",
        fontFamily: "monospace",
      }}
    >
      {text}
    </span>
  );
}

function Dash() {
  return <span style={{ color: "#ccc", fontSize: 12 }}>—</span>;
}

function DrawerField({ label, value, color }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          color: "#aaa",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 12, color: color || "#111", fontWeight: 600 }}>
        {value}
      </div>
    </div>
  );
}

// ─── RECEIPT MODAL ────────────────────────────────────────────────────────────
function ReceiptModal({ order, onClose }) {
  if (!order) return null;

  const isExpired = order.status === "Expired";
  const statusColor =
    order.status === "Completed"
      ? "#065f46"
      : order.status === "Refunded"
      ? "#374151"
      : "#6b7280";
  const statusBg =
    order.status === "Completed"
      ? "#d1fae5"
      : order.status === "Refunded"
      ? "#f3f4f6"
      : "#f3f4f6";

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        boxSizing: "border-box",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 14,
          width: "100%",
          maxWidth: 480,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          fontFamily: "inherit",
        }}
      >
        {/* Receipt Header */}
        <div
          style={{
            background: "#6B5FE4",
            borderRadius: "14px 14px 0 0",
            padding: "20px 22px 18px",
            color: "#fff",
            position: "relative",
          }}
        >
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              background: "rgba(255,255,255,0.15)",
              border: "none",
              borderRadius: "50%",
              width: 28,
              height: 28,
              cursor: "pointer",
              color: "#fff",
              fontSize: 14,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1,
            }}
          >
            ✕
          </button>
          <div style={{ fontSize: 11, opacity: 0.75, marginBottom: 4, letterSpacing: "0.05em" }}>
            WASHTA PLATFORM
          </div>
          <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 6 }}>
            Order Receipt
          </div>
          <div
            style={{
              fontFamily: "monospace",
              fontSize: 13,
              background: "rgba(255,255,255,0.15)",
              display: "inline-block",
              padding: "2px 10px",
              borderRadius: 6,
            }}
          >
            {getOrderNumber(order.rawId)}
            {/* {g} */}
          </div>
          <div style={{ marginTop: 10, fontSize: 11, opacity: 0.8 }}>
            {order.date} · {order.time}
          </div>
        </div>

        {/* Status Banner */}
        <div
          style={{
            background: statusBg,
            borderBottom: "1px solid #eee",
            padding: "8px 22px",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: statusColor,
              display: "inline-block",
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: 11, fontWeight: 700, color: statusColor }}>
            {order.status}
          </span>
          {order.stripeId && (
            <span
              style={{
                marginLeft: "auto",
                fontFamily: "monospace",
                fontSize: 9,
                color: "#888",
                wordBreak: "break-all",
              }}
            >
              {order.stripeId}
            </span>
          )}
        </div>

        {/* Body */}
        <div style={{ padding: "18px 22px", display: "flex", flexDirection: "column", gap: 18 }}>

          {/* Provider + Customer */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <ReceiptSection label="Provider">
              <div style={{ fontWeight: 700, fontSize: 13 }}>{order.provider}</div>
              <div style={{ fontSize: 11, color: "#888" }}>{order.location}</div>
            </ReceiptSection>
            <ReceiptSection label="Customer">
              <div style={{ fontWeight: 700, fontSize: 13 }}>{order.customer}</div>
              <div style={{ fontSize: 11, color: "#888" }}>{order.email}</div>
            </ReceiptSection>
          </div>

          {/* Vehicle */}
          <ReceiptSection label="Vehicle">
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span style={{ fontWeight: 700, fontSize: 13 }}>{order.vehicle}</span>
              <Plate text={order.plate} />
              <span
                style={{
                  fontSize: 10,
                  background: "#f0f0f0",
                  color: "#555",
                  borderRadius: 4,
                  padding: "1px 6px",
                  fontWeight: 600,
                }}
              >
                {order.carType}
              </span>
            </div>
          </ReceiptSection>

          {/* Service + Addons */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <ReceiptSection label="Service">
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#4a3db8",
                }}
              >
                {order.service}
              </span>
            </ReceiptSection>
            <ReceiptSection label="Add-ons">
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: order.addons === "—" ? "#ccc" : "#1a6641",
                }}
              >
                {order.addons}
              </span>
            </ReceiptSection>
          </div>

          {/* Promo */}
          {order.promoCode && (
            <div
              style={{
                background: "#fffbeb",
                border: "1px dashed #fbbf24",
                borderRadius: 8,
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <span style={{ fontSize: 16 }}>🏷️</span>
              <div>
                <span
                  style={{
                    fontFamily: "monospace",
                    fontWeight: 700,
                    fontSize: 12,
                    color: "#92400e",
                  }}
                >
                  {order.promoCode}
                </span>
                <span style={{ fontSize: 11, color: "#92400e", marginLeft: 6 }}>
                  applied
                  {order.promoDiscountRaw != null && (
                    <> · {order.promoDiscountType === 'percentage'
                      ? `${order.promoDiscountRaw}% off`
                      : `AED ${order.promoDiscountRaw.toFixed(2)} off`}</>
                  )}
                  {' '}· Washta absorbed −AED {Math.abs(order.promo).toFixed(2)}
                </span>
              </div>
            </div>
          )}

          {/* Financial Breakdown */}
          <div>
            <div
              style={{
                fontSize: 9,
                fontWeight: 700,
                color: "#aaa",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                marginBottom: 8,
              }}
            >
              Financial Breakdown
            </div>
            <div
              style={{
                border: "1px solid #eee",
                borderRadius: 10,
                overflow: "hidden",
              }}
            >
              {[
                {
                  label: "Base Service Price",
                  value: `AED ${order.baseShopPrice.toFixed(2)}`,
                  color: "#111",
                  bg: "#fff",
                },
                order.addonsTotal > 0 && {
                  label: "Add-ons Total",
                  value: `+AED ${order.addonsTotal.toFixed(2)}`,
                  color: "#1a6641",
                  bg: "#f0fdf4",
                },
                {
                  label: "Shop Price (incl. add-ons)",
                  value: `AED ${order.shopPrice.toFixed(2)}`,
                  color: "#111",
                  bg: "#f9f9f9",
                  bold: true,
                },
                order.promo != null && {
                  label: "Promo Discount",
                  value: `−AED ${Math.abs(order.promo).toFixed(2)}`,
                  color: "#92400e",
                  bg: "#fffbeb",
                },
                {
                  label: "Charged to Customer",
                  value: isExpired ? "—" : `AED ${order.charged?.toFixed(2)}`,
                  color: "#111",
                  bg: "#f9f9f9",
                  bold: true,
                },
                {
                  label: "  ↳ Washta Platform Fee (5%, capped AED 1.50–5.00) — included above",
                  value: isExpired
                    ? "—"
                    : `AED ${order.platformFee?.toFixed(2)}`,
                  color: "#4a3db8",
                  bg: "#f7f5ff",
                  italic: true,
                },
                {
                  label: "Stripe Processing Fee",
                  value: isExpired
                    ? "—"
                    : `−AED ${Math.abs(order.stripeFee).toFixed(2)}`,
                  color: "#991b1b",
                  bg: "#fff",
                },
                {
                  label: "Washta Commission (8%, from shop price)",
                  value: isExpired
                    ? "—"
                    : `+AED ${order.commission?.toFixed(2)}`,
                  color: "#4a3db8",
                  bg: "#f7f5ff",
                },
                {
                  label: "Washta Net Revenue",
                  value: isExpired ? "—" : `AED ${order.net?.toFixed(2)}`,
                  color: "#065f46",
                  bg: "#f0fdf4",
                  bold: true,
                },
                {
                  label: "Provider Entitlement",
                  value:
                    order.providerEntitlement != null
                      ? `AED ${order.providerEntitlement.toFixed(2)}`
                      : "—",
                  color: "#111",
                  bg: "#fff",
                },
              ]
                .filter(Boolean)
                .map((row, i, arr) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "9px 13px",
                      background: row.bg,
                      borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
                    }}
                  >
                    <span style={{ fontSize: row.italic ? 10 : 11, color: "#555", fontStyle: row.italic ? "italic" : "normal" }}>{row.label}</span>
                    <span
                      style={{
                        fontSize: 12,
                        fontFamily: "monospace",
                        fontWeight: row.bold ? 800 : 600,
                        color: row.color,
                      }}
                    >
                      {row.value}
                    </span>
                  </div>
                ))}
            </div>
          </div>

          {/* QB Note */}
          {order.status === "Completed" && (
            <div
              style={{
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 10,
                color: "#1a6641",
                lineHeight: 1.6,
              }}
            >
              ✅ QB Auto-sync: Entry No.1 fired on completion · one-way to QB only
            </div>
          )}

          {order.status === "Expired" && (
            <div
              style={{
                background: "#f0eeff",
                border: "1px solid #d8d2ff",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 10,
                color: "#4a3db8",
                lineHeight: 1.6,
              }}
            >
              ⏱ This order expired (acceptance window timed out). No payment was taken.
            </div>
          )}

          {order.status === "Refunded" && (
            <div
              style={{
                background: "#fff3cd",
                border: "1px solid #fbbf24",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 10,
                color: "#92400e",
                lineHeight: 1.6,
              }}
            >
              🔄 Order refunded. QB reversal journal may be required — flag to accountant.
            </div>
          )}
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "12px 22px 16px",
            borderTop: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <span style={{ fontSize: 10, color: "#aaa" }}>
            Generated by Washta Platform
          </span>
          <button
            onClick={onClose}
            style={{
              fontSize: 11,
              fontWeight: 600,
              padding: "7px 18px",
              background: "#6B5FE4",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

function ReceiptSection({ label, children }) {
  return (
    <div>
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          color: "#aaa",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          marginBottom: 5,
        }}
      >
        {label}
      </div>
      {children}
    </div>
  );
}

// ─── XLSX EXPORT ──────────────────────────────────────────────────────────────
function exportToXLSX(data) {
  const rows = data.map((o) => ({
    "Order ID": o.id,
    "Date": o.date,
    "Time": o.time,
    "Provider": o.provider,
    "Location": o.location,
    "Customer": o.customer,
    "Email": o.email,
    "Vehicle": o.vehicle,
    "Plate": o.plate,
    "Car Type": o.carType,
    "Service": o.service,
    "Add-ons": o.addons,
    "Promo Code": o.promoCode || "",
    "Shop Price (AED)": o.shopPrice,
    "Promo Discount (AED)": o.promo != null ? Math.abs(o.promo) : "",
    "Charged to Customer (AED)": o.charged != null ? o.charged : "",
    "Washta Platform Fee (AED)": o.platformFee != null ? o.platformFee : "",
    "Stripe Fee (AED)": o.stripeFee != null ? Math.abs(o.stripeFee) : "",
    "Commission (AED)": o.commission != null ? o.commission : "",
    "Washta Net (AED)": o.net != null ? o.net : "",
    "Provider Entitlement (AED)": o.providerEntitlement != null ? o.providerEntitlement : "",
    "Status": o.status,
    "Stripe Payment ID": o.stripeId || "",
  }));

  const ws = XLSX.utils.json_to_sheet(rows);

  // Column widths
  ws["!cols"] = [
    { wch: 20 }, { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 22 },
    { wch: 14 }, { wch: 22 }, { wch: 18 }, { wch: 10 }, { wch: 10 },
    { wch: 14 }, { wch: 18 }, { wch: 12 }, { wch: 18 }, { wch: 20 },
    { wch: 24 }, { wch: 22 }, { wch: 18 }, { wch: 18 }, { wch: 18 },
    { wch: 24 }, { wch: 12 }, { wch: 32 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "All Orders");

  // Summary sheet
  const completed = data.filter((o) => o.status === "Completed");
  const totalCharged = completed.reduce((s, o) => s + (o.charged || 0), 0);
  const totalNet = completed.reduce((s, o) => s + (o.net || 0), 0);
  const totalCommission = completed.reduce((s, o) => s + (o.commission || 0), 0);
  const totalPlatformFee = completed.reduce((s, o) => s + (o.platformFee || 0), 0);
  const totalProviderPayout = completed.reduce((s, o) => s + (o.providerEntitlement || 0), 0);

  const summaryRows = [
    { Metric: "Total Orders", Value: data.length },
    { Metric: "Completed", Value: data.filter((o) => o.status === "Completed").length },
    { Metric: "Refunded", Value: data.filter((o) => o.status === "Refunded").length },
    { Metric: "Expired", Value: data.filter((o) => o.status === "Expired").length },
    { Metric: "" },
    { Metric: "Total Charged to Customers (AED)", Value: +totalCharged.toFixed(2) },
    { Metric: "Total Washta Commission (AED)", Value: +totalCommission.toFixed(2) },
    { Metric: "Total Washta Platform Fee (AED)", Value: +totalPlatformFee.toFixed(2) },
    { Metric: "Total Stripe Fees (AED)", Value: +data.reduce((s, o) => s + Math.abs(o.stripeFee || 0), 0).toFixed(2) },
    { Metric: "Total Washta Net (AED)", Value: +totalNet.toFixed(2) },
    { Metric: "Total Provider Payouts (AED)", Value: +totalProviderPayout.toFixed(2) },
  ];

  const ws2 = XLSX.utils.json_to_sheet(summaryRows);
  ws2["!cols"] = [{ wch: 38 }, { wch: 18 }];
  XLSX.utils.book_append_sheet(wb, ws2, "Summary");

  XLSX.writeFile(wb, `Washta_Orders_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function AllOrders() {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All Statuses");
  const [providerFilter, setProviderFilter] = useState("All Providers");
  const [serviceFilter, setServiceFilter] = useState("All Services");
  const [search, setSearch] = useState("");
  const [refundConfirm, setRefundConfirm] = useState(false);
  const [refundReason, setRefundReason] = useState("");
  const [mobileDrawer, setMobileDrawer] = useState(false);
  const [receiptOrder, setReceiptOrder] = useState(null); // receipt modal
  const [timeFilter, setTimeFilter] = useState("Today");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("accessTokenAdmin");
        if (!token) return;

        // Backend caps each page at 100 orders, so walk every page for "All Time".
        let rawOrders = [];
        let page = 1;
        let hasNextPage = true;
        while (hasNextPage && page <= 200) {
          const response = await axios.get(`${DASHBOARD_V2_URL}/orders?limit=100&page=${page}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const data = response.data?.data;
          rawOrders = rawOrders.concat(data?.orders || (Array.isArray(data) ? data : []));
          hasNextPage = Boolean(data?.pagination?.hasNextPage);
          page += 1;
        }

        const rows = rawOrders.map(transformOrder);
        setOrders(rows);
        setSelectedOrder((current) => current || rows[0] || null);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, []);


const filtered = useMemo(() => {
  const now = moment();
  let rangeStart = moment(now).startOf('day');
  if (timeFilter === "This Week") {
    rangeStart = moment(now).subtract(6, 'days').startOf('day');
  } else if (timeFilter === "This Month") {
    rangeStart = moment(now).subtract(29, 'days').startOf('day');
  } else if (timeFilter === "All Time") {
    rangeStart = null;
  }

  return orders.filter((order) => {
    if (rangeStart && order.createdAt) {
      const orderDate = moment.utc(order.createdAt).local();
      if (orderDate.isBefore(rangeStart)) return false;
    }
    if (statusFilter !== "All Statuses" && order.status !== statusFilter) return false;
    if (providerFilter !== "All Providers" && order.provider !== providerFilter) return false;
    if (serviceFilter !== "All Services" && order.service !== serviceFilter) return false;
    if (
      search &&
      ![order.id, order.plate, order.customer, order.stripeId || ""]
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    ) {
      return false;
    }
    return true;
  });
}, [orders, timeFilter, statusFilter, providerFilter, serviceFilter, search]);
  const providerOptions = useMemo(
    () => ["All Providers", ...Array.from(new Set(orders.map((order) => order.provider).filter(Boolean)))],
    [orders]
  );

  const serviceOptions = useMemo(
    () => ["All Services", ...Array.from(new Set(orders.map((order) => order.service).filter(Boolean)))],
    [orders]
  );

  function openDrawer(order) {
    setSelectedOrder(order);
    setDrawerOpen(true);
    setRefundConfirm(false);
    setRefundReason("");
    setMobileDrawer(true);
  }

  return (
    <div
      className="mainDiv-all-sideBar"
      style={{ display: "flex", minHeight: "100vh", background: "#f0f0f5" }}
    >
      <div className="div-sidebar">
        <AdminSidebar />
      </div>

      <div
        className="div-Dashbaord"
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",padding:0,
          background:'white'
        }}
      >
        <div style={{ flex: 1, display: "flex", minHeight: 0, overflow: "hidden" }}>
          <div
            style={{
              flex: 1,
              minWidth: 0,
              overflowY: "auto",
              padding: "20px 20px 40px",
            }}
          >
           <h1 className='ws-view-title'>
              All Orders
            </h1>
            <p style={{ fontSize: 11, color: "#888", marginBottom: 14, lineHeight: 1.5 }}>
              Every transaction across all providers. Click any row to open order detail.
              Expired rows show full data — no money moved.
            </p>

            {/* FILTERS */}
            <div
              style={{
                display: "flex",
                gap: 7,
                alignItems: "center",
                marginBottom: 14,
                flexWrap: "wrap",
              }}
            >
              {["Today", "This Week", "This Month", "All Time"].map((d) => (
  <button
    key={d}
    onClick={() => setTimeFilter(d)}
    style={{
      fontSize: 10,
      padding: "4px 10px",
      border: "1px solid #ddd",
      borderRadius: 20,
      color: timeFilter === d ? "#fff" : "#888",
      cursor: "pointer",
      background: timeFilter === d ? "#6B5FE4" : "#fff",
      borderColor: timeFilter === d ? "#6B5FE4" : "#ddd",
    }}
  >
    {d}
  </button>
))}
              {[
                {
                  value: providerFilter,
                  onChange: setProviderFilter,
                  options: providerOptions,
                },
                {
                  value: statusFilter,
                  onChange: setStatusFilter,
                  options: ["All Statuses", "Completed", "Refunded", "Expired"],
                },
                {
                  value: serviceFilter,
                  onChange: setServiceFilter,
                  options: serviceOptions,
                },
              ].map(({ value, onChange, options }, i) => (
                <select
                  key={i}
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  style={{
                    fontSize: 11,
                    color: "#111",
                    border: "1px solid #ddd",
                    borderRadius: 7,
                    padding: "5px 8px",
                    background: "#fff",
                    fontFamily: "inherit",
                  }}
                >
                  {options.map((o) => (
                    <option key={o}>{o}</option>
                  ))}
                </select>
              ))}
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Order ID, plate, customer, Stripe ID…"
                style={{
                  fontSize: 11,
                  border: "1px solid #ddd",
                  borderRadius: 7,
                  padding: "5px 9px",
                  background: "#fff",
                  color: "#111",
                  fontFamily: "inherit",
                  width: 200,
                  marginLeft: "auto",
                }}
              />
              {/* ↓ EXPORT BUTTON */}
              <button
                onClick={() => exportToXLSX(filtered)}
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  padding: "5px 11px",
                  borderRadius: 7,
                  cursor: "pointer",
                  background: "#fff",
                  color: "#111",
                  border: "1px solid #ddd",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                ↓ Export
              </button>
            </div>

            {/* TABLE */}
            <div style={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: 900,
                }}
              >
                <thead>
                  <tr>
                    {[
                      "Order ID",
                      "Date / Time",
                      "Provider · Location",
                      "Customer",
                      "Vehicle",
                      "Service",
                      "Shop Price",
                      "Promo",
                      "Charged",
                      "Stripe Fee",
                      "Commission",
                      "Net",
                      "Status",
                    ].map((h, i) => (
                      <th
                        key={h}
                        style={{
                          fontSize: 9,
                          fontWeight: 700,
                          color: "#aaa",
                          textTransform: "uppercase",
                          letterSpacing: "0.06em",
                          padding: "7px 10px",
                          textAlign: i >= 6 && i <= 11 ? "right" : "left",
                          borderBottom: "1.5px solid #eee",
                          background: "#f7f7f9",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((order) => {
                    const isExpired = order.status === "Expired";
                    const isRefunded = order.status === "Refunded";
                    const isSelected = selectedOrder?.id === order.id && drawerOpen;
                    return (
                      <tr
                        key={order.id}
                        onClick={() => openDrawer(order)}
                        style={{
                          cursor: "pointer",
                          background: isRefunded
                            ? "#fffbeb"
                            : isSelected
                            ? "#f0eeff"
                            : "transparent",
                          transition: "background 0.1s",
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) e.currentTarget.style.background = "#fafafa";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = isRefunded
                            ? "#fffbeb"
                            : isSelected
                            ? "#f0eeff"
                            : "transparent";
                        }}
                      >
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div
                            style={{
                              fontSize: 10,
                              color: "#6B5FE4",
                              fontFamily: "monospace",
                              fontWeight: 600,
                            }}
                          >
                            {getOrderNumber(order?.rawId)}
                            
                          </div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontSize: 11 }}>{order.date}</div>
                          <div style={{ fontSize: 10, color: "#aaa" }}>{order.time}</div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontWeight: 700, fontSize: 11 }}>{order.provider}</div>
                          <div style={{ fontSize: 10, color: "#888" }}>{order.location}</div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontSize: 11 }}>{order.customer}</div>
                          <div style={{ fontSize: 10, color: "#aaa" }}>{order.email}</div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontSize: 11 }}>{order.vehicle}</div>
                          <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
                            <Plate text={order.plate} />
                            <span style={{ fontSize: 9, color: "#888" }}>{order.carType}</span>
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            fontSize: 11,
                            color: isExpired ? "#aaa" : "#4a3db8",
                            fontWeight: 600,
                          }}
                        >
                          {order.service}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                          }}
                        >
                          AED {order.shopPrice.toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            color: "#92400e",
                          }}
                        >
                          {order.promo ? `−${Math.abs(order.promo).toFixed(2)}` : <Dash />}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                          }}
                        >
                          {isExpired ? <Dash /> : order.charged?.toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            color: "#991b1b",
                          }}
                        >
                          {isExpired ? <Dash /> : `−${Math.abs(order.stripeFee).toFixed(2)}`}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            color: "#4a3db8",
                          }}
                        >
                          {isExpired ? <Dash /> : order.commission != null ? `+${order.commission.toFixed(2)}` : <Dash />}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            fontWeight: 700,
                          }}
                        >
                          {isExpired ? <Dash /> : order.net != null ? order.net.toFixed(2) : <Dash />}
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <StatusPill status={order.status} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div
              style={{
                fontSize: 11,
                color: "#888",
                marginTop: 10,
                paddingTop: 10,
                borderTop: "1px solid #f0f0f0",
              }}
            >
              Showing {filtered.length} of {orders.length} ·{" "}
              {/* <span style={{ color: "#6B5FE4", cursor: "pointer" }}>Load more →</span> */}
            </div>
          </div>

          {/* RIGHT DRAWER PANEL (desktop) */}
          {drawerOpen && selectedOrder && (
            <div
              style={{
                width: 320,
                flexShrink: 0,
                borderLeft: "1px solid #eee",
                overflowY: "auto",
                background: "#fff",
              }}
            >
              {/* Drawer Header */}
              <div
                style={{
                  background: "#f7f7f9",
                  borderBottom: "1px solid #eee",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>
                    Order Detail
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#6B5FE4",
                      fontFamily: "monospace",
                      marginTop: 2,
                    }}
                  >
                     {getOrderNumber(selectedOrder?.rawId)}

                    {/* {selectedOrder.id} */}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <StatusPill status={selectedOrder.status} />
                  <button
                    onClick={() => { setDrawerOpen(false); setMobileDrawer(false); }}
                    style={{
                      fontSize: 16,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#888",
                      lineHeight: 1,
                      padding: "0 4px",
                    }}
                  >
                    ✕
                  </button>
                </div>
              </div>

              {/* Drawer Body */}
              <div
                style={{
                  padding: 14,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 14,
                }}
              >
                <DrawerField
                  label="Washta Order ID"
                  value={
                    <span style={{ fontFamily: "monospace", fontSize: 11, color: "#6B5FE4" }}>
                      {/* {selectedOrder.id} */}
                    {getOrderNumber(selectedOrder?.rawId)}

                    </span>
                  }
                />
                <DrawerField
                  label="Date / Time"
                  value={`${selectedOrder.date} · ${selectedOrder.time}`}
                />
                <div style={{ gridColumn: "1 / -1" }}>
                  <DrawerField
                    label="Stripe Payment ID"
                    value={
                      selectedOrder.stripeId ? (
                        <span style={{ fontFamily: "monospace", fontSize: 10, color: "#111" }}>
                          {selectedOrder.stripeId}
                        </span>
                      ) : (
                        <span style={{ color: "#aaa", fontSize: 11 }}>— not charged</span>
                      )
                    }
                  />
                </div>
                <DrawerField
                  label="Provider · Location"
                  value={`${selectedOrder.provider} · ${selectedOrder.location}`}
                />
                <DrawerField
                  label="Customer"
                  value={`${selectedOrder.customer} · ${selectedOrder.email}`}
                />
                <DrawerField
                  label="Vehicle"
                  value={
                    <span>
                      {selectedOrder.vehicle} · <Plate text={selectedOrder.plate} /> ·{" "}
                      {selectedOrder.carType}
                    </span>
                  }
                />
                <DrawerField
                  label="Service"
                  value={<span style={{ color: "#4a3db8" }}>{selectedOrder.service}</span>}
                />
                <DrawerField
                  label="Add-ons"
                  value={<span style={{ color: "#1a6641" }}>{selectedOrder.addons}</span>}
                />
                <DrawerField
                  label="Promo Code"
                  value={
                    selectedOrder.promoCode
                      ? `${selectedOrder.promoCode}${selectedOrder.promoDiscountRaw != null ? ` · ${selectedOrder.promoDiscountType === 'percentage' ? `${selectedOrder.promoDiscountRaw}% off` : `AED ${selectedOrder.promoDiscountRaw.toFixed(2)} off`}` : ''} · −AED ${Math.abs(selectedOrder.promo).toFixed(2)} · Washta absorbed`
                      : "None"
                  }
                />
                <DrawerField
                  label="Base Service Price"
                  value={`AED ${selectedOrder.baseShopPrice.toFixed(2)}`}
                />
                <DrawerField
                  label="Add-ons Total"
                  value={
                    selectedOrder.addonsTotal > 0
                      ? <span style={{ color: "#1a6641" }}>+AED {selectedOrder.addonsTotal.toFixed(2)}</span>
                      : "—"
                  }
                />
                <DrawerField
                  label="Shop Price (incl. add-ons)"
                  value={`AED ${selectedOrder.shopPrice.toFixed(2)}`}
                />
                <DrawerField
                  label="Charged to Customer"
                  value={
                    selectedOrder.charged != null
                      ? `AED ${selectedOrder.charged.toFixed(2)}`
                      : "—"
                  }
                />
                <DrawerField
                  label="Platform Fee (5%, capped 1.50–5.00) — incl. in charged"
                  value={
                    selectedOrder.platformFee != null ? (
                      <span style={{ color: "#4a3db8" }}>
                        AED {selectedOrder.platformFee.toFixed(2)}
                      </span>
                    ) : (
                      "—"
                    )
                  }
                />
                <DrawerField
                  label="Stripe Fee"
                  value={
                    selectedOrder.stripeFee != null ? (
                      <span style={{ color: "#991b1b" }}>
                        − AED {Math.abs(selectedOrder.stripeFee).toFixed(2)}
                      </span>
                    ) : (
                      "—"
                    )
                  }
                />
                <DrawerField
                  label="Commission (8% shop price)"
                  value={
                    selectedOrder.commission != null ? (
                      <span style={{ color: "#4a3db8" }}>
                        + AED {selectedOrder.commission.toFixed(2)}
                      </span>
                    ) : (
                      "—"
                    )
                  }
                />
                <DrawerField
                  label="Washta Net"
                  value={
                    selectedOrder.net != null ? (
                      <span style={{ color: "#1a6641" }}>
                        AED {selectedOrder.net.toFixed(2)}
                      </span>
                    ) : (
                      "—"
                    )
                  }
                />
                <DrawerField
                  label="Provider Entitlement"
                  value={
                    selectedOrder.providerEntitlement != null
                      ? `AED ${selectedOrder.providerEntitlement.toFixed(2)}`
                      : "—"
                  }
                />
                <div style={{ gridColumn: "1 / -1" }}>
                  <DrawerField
                    label="QB Auto-sync"
                    value={
                      selectedOrder.status === "Completed" ? (
                        <span style={{ fontSize: 11, color: "#1a6641" }}>
                          Entry No.1 fired on completion · one-way to QB only
                        </span>
                      ) : (
                        <span style={{ fontSize: 11, color: "#aaa" }}>— not applicable</span>
                      )
                    }
                  />
                </div>
              </div>

              {/* Drawer Actions */}
              <div
                style={{
                  padding: "12px 14px",
                  background: "#fafafa",
                  borderTop: "1px solid #eee",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                }}
              >
                {/* VIEW RECEIPT — opens modal */}
                <button
                  onClick={() => setReceiptOrder(selectedOrder)}
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    padding: "6px 14px",
                    background: "#fff",
                    color: "#6B5FE4",
                    border: "1px solid #d8d2ff",
                    borderRadius: 7,
                    cursor: "pointer",
                  }}
                >
                  View Receipt
                </button>
                {selectedOrder.status === "Completed" && (
                  <button
                    onClick={() => setRefundConfirm(true)}
                    style={{
                      fontSize: 10,
                      fontWeight: 700,
                      padding: "6px 14px",
                      background: "#fee2e2",
                      color: "#991b1b",
                      border: "1px solid #fca5a5",
                      borderRadius: 7,
                      cursor: "pointer",
                    }}
                  >
                    🚩 Flag for Refund
                  </button>
                )}
              </div>

              {/* Refund Confirm */}
              {refundConfirm && (
                <div style={{ padding: "10px 14px 14px" }}>
                  <div
                    style={{
                      background: "#fff3cd",
                      border: "1px solid #fbbf24",
                      borderRadius: 8,
                      padding: "10px 12px",
                      marginBottom: 10,
                      fontSize: 10,
                      color: "#92400e",
                      lineHeight: 1.6,
                    }}
                  >
                    ⚠️ This will mark order as Refunded, notify customer, and log an audit entry.
                    Actual Stripe refund must be processed separately in Stripe Dashboard.
                  </div>
                  <textarea
                    value={refundReason}
                    onChange={(e) => setRefundReason(e.target.value)}
                    placeholder="Reason for refund (required)…"
                    rows={3}
                    style={{
                      width: "100%",
                      fontSize: 11,
                      border: "1px solid #ddd",
                      borderRadius: 7,
                      padding: "7px 9px",
                      fontFamily: "inherit",
                      resize: "vertical",
                      marginBottom: 8,
                      boxSizing: "border-box",
                    }}
                  />
                  <div style={{ display: "flex", gap: 8 }}>
                    <button
                      onClick={() => setRefundConfirm(false)}
                      style={{
                        flex: 1,
                        fontSize: 10,
                        fontWeight: 600,
                        padding: "6px 0",
                        background: "#fff",
                        color: "#666",
                        border: "1px solid #ddd",
                        borderRadius: 7,
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      disabled={!refundReason.trim()}
                      style={{
                        flex: 2,
                        fontSize: 10,
                        fontWeight: 700,
                        padding: "6px 0",
                        background: refundReason.trim() ? "#fee2e2" : "#f3f4f6",
                        color: refundReason.trim() ? "#991b1b" : "#aaa",
                        border: `1px solid ${refundReason.trim() ? "#fca5a5" : "#eee"}`,
                        borderRadius: 7,
                        cursor: refundReason.trim() ? "pointer" : "not-allowed",
                      }}
                    >
                      Confirm Refund Flag
                    </button>
                  </div>
                </div>
              )}

              {selectedOrder.status !== "Completed" && (
                <div
                  style={{
                    margin: "0 14px 14px",
                    background: "#f0eeff",
                    border: "1px solid #d8d2ff",
                    borderRadius: 8,
                    padding: "8px 12px",
                    fontSize: 10,
                    color: "#4a3db8",
                    lineHeight: 1.5,
                  }}
                >
                  {selectedOrder.status === "Expired"
                    ? "This order expired (acceptance window timed out). No payment was taken — no financial impact."
                    : "This order has already been refunded. QB reversal journal may be required — flag to accountant."}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* RECEIPT MODAL */}
      {receiptOrder && (
        <ReceiptModal order={receiptOrder} onClose={() => setReceiptOrder(null)} />
      )}

      <style>{`
        @media (max-width: 768px) {
          .mainDiv-all-sideBar {
            flex-direction: column;
          }
          .div-sidebar {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
}